// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T16:24:21.474Z
// Property: Black Canyon Luxury Apartments (ID: 6767906449167563)
// Collections: 22 amenities, 5 floorplans (live), 20 photos, 65 POIs, 47 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167563",
  "property_external_id": "1205BLCN",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/ascend-at-black-canyon/CkCNYZ/",
  "property_apartments_url": "https://www.apartments.com/ascend-at-black-canyon-phoenix-az/7xr1t5w/",
  "property_google_business_url": "https://www.google.com/maps/place/?q=place_id:ChIJxdA9JeFlK4cRZ4xs_0TEWoA",
  "property_linkedin_url": null,
  "property_hubspot_id": "56463520032",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1205BLCN",
  "property_status": null,
  "property_slug": "black-canyon-luxury-apartments",
  "property_name": "Black Canyon Luxury Apartments",
  "property_website_url": "https://www.liveatblackcanyon.com/",
  "property_domain": "https://www.liveatblackcanyon.com/",
  "property_address": "28201 N Black Cyn Hwy",
  "property_full_address": "28201 N Black Canyon Hwy, Phoenix, AZ 85085",
  "property_address_1": "28201 N Black Canyon Hwy",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": "85085",
  "property_address_zip": "85085",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Deer Valley",
  "property_address_latitude": "33.7398252",
  "property_address_longitude": "-112.1217839",
  "property_email": "amc_blackcanyonluxury_web_propertywebsite@leads.anyonehome.com",
  "property_phone": "8776575164",
  "property_call_tracking_phone": "6025842772",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern North Phoenix living with room to unwind.</strong> Explore one-, two-, and three-bedroom apartments with polished finishes, private outdoor space, and everyday comforts—then schedule a tour to see Black Canyon Luxury Apartments in person.</p>",
  "property_long_description": "<p><strong>Modern North Phoenix living with room to unwind.</strong> At Black Canyon Luxury Apartments in Deer Valley, you can choose from one-, two-, and three-bedroom layouts—including a loft-style option with garage—and settle into polished interiors with granite-countertop gourmet kitchens, stainless steel energy-efficient appliances, hardwood-style flooring, smart thermostats, full-size washer and dryer, walk-in closets with built-in shelving, and a private patio or balcony.</p><p>Outside your door, the community keeps everyday life streamlined with a <a href=\"/amenities\">resort-style pool</a>, poolside ramada and BBQ grills, 24-hour fitness center with yoga studio, clubhouse Wi-Fi, package lockers, pet wash, fire pits, gaming areas, valet trash, controlled access, and responsive on-site service. Just off I-17 in North Phoenix, you’re close to Sonoran Preserve trails, The Shops at Norterra, Happy Valley Towne Center, Harkins Norterra 14, Martin Auto Museum, and the growing Deer Valley/Norterra employment corridor—giving you desert recreation, dining, shopping, and commuting routes within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f7df0-ce29-74a7-8231-db02db900e31.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019f7df0-ce29-74a7-8231-db02db900e31",
    "storage_key": "property/6767906449167563/019f7df0-ce29-74a7-8231-db02db900e31.webp",
    "width": 2000,
    "height": 1497
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "260",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "2",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.53846153846153",
  "property_admin_fee": "300",
  "property_application_fee": "70",
  "property_fees_deposit_info": "Security Deposit\n$300 -1 Month's Rent\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed, maximum 2 pets per unit. Prohibited pets include livestock, farm animals (including potbellied pigs), and poisonous, dangerous, or exotic animals (such as snakes and spiders). Certain dog breeds are prohibited, including American Pit Bull Terrier, American Staffordshire Terrier, Bull Mastiff, Akita, Chow, Doberman, Pit Bull, Presa Canario, Rottweiler, Wolf, Wolf hybrids, and any combination thereof.",
  "property_pet_policy_description": "Cats and dogs allowed, maximum 2 pets per unit. One-time pet fee: $350 per pet. Monthly pet rent: $35 per pet. Prohibited pets include livestock, farm animals (including potbellied pigs), and poisonous, dangerous, or exotic animals (such as snakes and spiders). Certain dog breeds are prohibited, including American Pit Bull Terrier, American Staffordshire Terrier, Bull Mastiff, Akita, Chow, Doberman, Pit Bull, Presa Canario, Rottweiler, Wolf, Wolf hybrids, and any combination thereof.",
  "property_petpolicy_info": "Pet Policy\n■\n2 Pets Per Apartment Maximum\n\n■\nDogs or Cats Welcome\n\n■\n$50/Monthly Pet Rent Per Pet\n\n■\nOne-Time $500 Pet Fee Per Pet",
  "property_online_leasing_url": "https://myrentalapplication.com/index/amcblackcanyonluxury",
  "property_resident_portal_url": "https://blackcanyon.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcblackcanyonluxury",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a01a4c-18dc-718c-8fcc-609084f79c61.webp",
  "property_primary_logo_media": {
    "alt_text": "Black Canyon Luxury Apartments logo",
    "public_id": "01a01a4c-18dc-718c-8fcc-609084f79c61",
    "storage_key": "property/6767906449167563/01a01a4c-18dc-718c-8fcc-609084f79c61.webp",
    "width": 1350,
    "height": 491
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a01a4c-a3db-7054-8111-d0ebc4138970.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a01a4c-a3db-7054-8111-d0ebc4138970",
    "storage_key": "property/6767906449167563/01a01a4c-a3db-7054-8111-d0ebc4138970.webp",
    "width": 1280,
    "height": 465
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a01a4c-9b7c-7722-942d-f175615c400d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a01a4c-9b7c-7722-942d-f175615c400d",
    "storage_key": "property/6767906449167563/01a01a4c-9b7c-7722-942d-f175615c400d.webp",
    "width": 1280,
    "height": 465
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "664 - 1,346 sq ft",
  "property_sqft_min": "664",
  "property_sqft_max": "1,346",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 22,
  "property_facebook_url": null,
  "property_instagram_url": "https://www.instagram.com/blackcanyonluxuryapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJxdA9JeFlK4cRZ4xs_0TEWoA",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Black Canyon Luxury Apartments",
  "property_home_romance_title": "Embrace Your Dream Home and Cherished Community Connections",
  "property_home_amenities_blurb": "<p><strong>Resort-inspired ease, every day.</strong> At Black Canyon Luxury Apartments, unwind by the resort-style pool, recharge in the 24-hour fitness center and yoga studio, or meet up around the ramada, BBQs, fire pits, clubhouse Wi-Fi, and gaming spaces. Inside, granite countertops, stainless steel energy-efficient appliances, hardwood-style flooring, full-size laundry, smart thermostats, built-in closet shelving, and a patio or balcony keep home polished and practical.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to live your way.</strong><br>Explore one-, two-, and three-bedroom apartments in Deer Valley, including a standout loft-style floor plan with garage. Open living areas, private patios or balconies, full-size washers and dryers, built-in closet shelving, and granite-and-stainless kitchens bring polished function to every floor plan. Check featured layouts, then click through for current pricing and availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Black Canyon Luxury Apartments.</strong> Preview polished interiors with granite counters, stainless steel appliances, pendant lighting, hardwood-style flooring, and patios or balconies that open up your space.</p><p>Then picture the community details: a resort-style pool with shaded ramada, BBQ grills, fire pit lounges, a clubhouse, and a 24-hour fitness center with yoga studio—all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Phoenix, right on your route.</strong> From Black Canyon Luxury Apartments in Deer Valley, open desert trails, Happy Valley Road conveniences, and Norterra shopping are all close by. Hit Apache Wash Loop in the Phoenix Sonoran Preserve, catch dinner or a movie at The Shops at Norterra, or handle everyday errands at Happy Valley Towne Center. With I-17 and Happy Valley Park-and-Ride nearby, getting across Phoenix—or out of town—stays simple.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight the service, setting, and space.</strong> Reviews praise tour experiences that feel clear and helpful, with a leasing team described as patient, knowledgeable, and thorough. Visitors also point to transparent pricing, multiple apartment options, and questions answered without pressure.</p><p>Across the community, reviewers call out a “quiet and veryyy clean” atmosphere, plus apartments that feel stunning, spacious, and thoughtfully laid out. Read more to see what continues to stand out at Black Canyon Luxury Apartments.</p>",
  "property_neighborhood_blurb": "<p><strong>North Phoenix, mapped to your everyday rhythm.</strong> In Deer Valley, Black Canyon Luxury Apartments places you close to open desert, growing commerce, and the easy pull of Happy Valley Road. Start with a cool morning on Apache Wash Loop in the Phoenix Sonoran Preserve, then swing by The Shops at Norterra for dining, errands, services, or a movie at Harkins Norterra 14. Nearby Happy Valley Towne Center adds grocery runs, casual restaurants, and daily essentials without sending you across town.</p><p>With I-17 and the Happy Valley Park-and-Ride close by, routes toward downtown Phoenix, the Deer Valley employment corridor, and weekend escapes north stay simple. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make every day run smoother.</strong> At Black Canyon Luxury Apartments, resort-inspired spaces and practical conveniences come together in North Phoenix. Start with the 24-hour fitness center and yoga studio, cool off at the resort-style pool, or settle into the poolside ramada, BBQ areas, fire pits, clubhouse Wi-Fi, and gaming spaces when you want a change of scene.</p><p>Back at home, polished finishes keep things easy: granite countertops, stainless steel energy-efficient appliances, hardwood-style flooring, full-size laundry, smart thermostats, walk-in closets with built-in shelving, and your own patio or balcony. Package lockers, valet trash, controlled access, garage options, and a pet washing station add even more everyday ease. See the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for modern North Phoenix living?</strong> Start your application for Black Canyon Luxury Apartments and choose from spacious one-, two-, or three-bedroom <a href=\"/floor-plans\">floor plans</a> with polished interiors, smart thermostats, full-size washers and dryers, and private patios or balconies—all in a Deer Valley community designed for everyday ease.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Black Canyon Luxury Apartments leasing team to learn more about one-, two-, and three-bedroom layouts, polished interior finishes, community conveniences, or getting directions to our North Phoenix location just off I-17.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Black Canyon Luxury Apartments?</strong> Start here for quick answers about our North Phoenix community, leasing details, apartment features, amenities, and everyday living. If you don’t see what you need, the responsive on-site leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that feels easy from day one.</strong><br>At Black Canyon Luxury Apartments in Deer Valley, you can compare one-, two-, and three-bedroom layouts, including a distinctive loft-style option with garage. Each home balances polished design with everyday function: open living space, a private patio or balcony, full-size washer and dryer, walk-in closets with built-in shelving, and gourmet kitchens with granite countertops and stainless steel energy-efficient appliances.</p><p>Use the floor plan cards below to check current pricing, availability, and layout details, then picture how your furniture, storage needs, and daily routine fit. Want to see the finishes up close? Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_gallery_blurb": "<p><strong>See the details that make Black Canyon Luxury Apartments feel polished from the first look.</strong> Browse bright interiors with granite kitchen counters, stainless steel appliances, pendant lighting, hardwood-style flooring, and private patios or balconies that extend your space outdoors.</p><p>The gallery also gives you a closer view of the community’s most photogenic spots: the <a href=\"/amenities\">resort-style pool</a> framed by a shaded ramada and BBQ grills, lounge areas with fire pits, a clubhouse made for laid-back downtime, and a 24-hour fitness center with a dedicated yoga studio. From one-bedroom layouts to spacious three-bedroom homes and a loft-style option with garage, each image helps you picture the finishes, flow, and everyday convenience waiting in Deer Valley. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Black Canyon on the map.</strong> Browse available one-, two-, and three-bedroom apartments, then see how this North Phoenix address puts desert recreation, shopping, dining, and I-17 commuting routes within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, polished for you.</strong><br>At Black Canyon Luxury Apartments, your cat or dog can settle into a home designed to make pet care feel simple—think private patio or balcony space, smoke-free surroundings, and an on-site pet washing station for rinsing off desert dust after a walk. When everyday errands call, nearby Happy Valley Road puts veterinary care and pet supplies within easy reach, while package lockers and valet trash help keep your routine moving. Review the policy details below for pet limits, fees, and breed guidelines, then explore more pet-friendly conveniences on the <a href=\"/amenities\">amenities page</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community in person.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Black Canyon?</strong> Share the polished interiors, room-to-unwind layouts, and North Phoenix convenience with a friend. Send an invite today and let them see why this Deer Valley community is easy to recommend.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Black Canyon Luxury Apartments.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with ease—supported by responsive on-site service and the streamlined convenience that defines modern North Phoenix living.</p>",
  "property_reviews_blurb": "<p><strong>Hear what stands out at Black Canyon Luxury Apartments.</strong> Resident reviews often point to a tour experience that feels helpful, detailed, and easy to navigate, with the leasing team praised for being patient, knowledgeable, and thorough.</p><p>You’ll see mentions of multiple apartment options, clear pricing details, and questions answered along the way. Reviewers also call out a community that feels “quiet and veryyy clean,” along with apartments described as stunning, spacious, and thoughtfully laid out. If you’re comparing homes in Deer Valley, these reviews offer a closer look at the service, atmosphere, and apartment features that made a strong impression.</p>",
  "property_created_at": "1784227963481",
  "property_scheduletour_blurb": "<p><strong>See Black Canyon in person.</strong> Tour spacious one-, two-, and three-bedroom layouts with polished finishes like granite countertops, stainless steel appliances, smart thermostats, walk-in closets, and private outdoor space—then picture your routine with a resort-style pool, fitness center, clubhouse Wi-Fi, and more just outside your door.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon with more details about Black Canyon Luxury Apartments. In the meantime, picture modern North Phoenix living with granite-countertop kitchens, smart thermostats, walk-in closets, private outdoor space, and everyday perks designed to help life feel streamlined.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Black Canyon Luxury Apartments",
  "property_seo_title_home": "Black Canyon Luxury Apartments |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Discover luxury at Black Canyon Apartments in Phoenix! Enjoy resort-style amenities, spacious layouts, and a vibrant community. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Black Canyon Luxury Apartments in Phoenix, AZ. Choose from stylish one, two, and three-bedroom floor plans tailored for you!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Discover unmatched comfort at Black Canyon Luxury Apartments in Phoenix! Enjoy resort-style amenities and a vibrant community. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Discover tranquility at Black Canyon Luxury Apartments in Phoenix. Explore spacious floor plans and resort-style amenities tailored for your lifestyle!",
  "property_seo_title_virtualtours": "Virtual Tours | Black Canyon Luxury Apartments Apartments",
  "property_seo_description_virtualtours": "Discover Black Canyon Luxury Apartments in Phoenix! Explore our one, two, and three-bedroom homes with a virtual tour. Your new lifestyle awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Black Canyon Luxury Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Black Canyon Luxury Apartments! Explore layouts and amenities with our interactive map for a lifestyle upgrade.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Discover Black Canyon Luxury Apartments in Phoenix, where local favorites and vibrant spots create your perfect neighborhood!",
  "property_seo_title_contact": "Contact Us | Black Canyon Luxury Apartments",
  "property_seo_description_contact": "Experience luxury living at Black Canyon Apartments in Phoenix, AZ. Inquire about our stunning one, two, and three-bedroom floor plans today!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Uncover all the essential info about Black Canyon Luxury Apartments in Phoenix. Our FAQs cover everything from floor plans to amenities—your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Join Black Canyon Luxury Apartments in Phoenix! Discover why residents love our stunning homes and amenities that make this community feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Discover luxury at Black Canyon Apartments, Phoenix! Enjoy spacious layouts and upscale amenities. Apply online for your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Black Canyon Luxury Apartments",
  "property_seo_description_residentaccess": "Log in to Black Canyon Luxury Apartments' portal in Phoenix for easy rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Black Canyon Luxury Apartments",
  "property_seo_description_referafriend": "Elevate your life at Black Canyon Luxury Apartments! Refer a friend for exclusive perks in Phoenix’s top community. Great neighbors await!",
  "property_seo_title_scheduletour": "Schedule a Tour | Black Canyon Luxury Apartments",
  "property_seo_description_scheduletour": "Experience elevated living at Black Canyon Luxury Apartments in Phoenix. Schedule your tour today and step into a world of modern comfort and style!",
  "property_seo_title_privacy": "Privacy Policy | Black Canyon Luxury Apartments",
  "property_seo_description_privacy": "Safeguarding your personal information is our priority at Black Canyon Luxury Apartments. Read our privacy policy to see how we protect you in Phoenix, AZ.",
  "property_seo_title_accessibility": "Website Accessibility | Black Canyon Luxury Apartments",
  "property_seo_description_accessibility": "Experience digital inclusion at Black Canyon Luxury Apartments in Phoenix, AZ. Your comfort matters—see how we ensure accessibility for everyone.",
  "property_seo_title_sitemap": "Sitemap | Black Canyon Luxury Apartments",
  "property_seo_description_sitemap": "Navigate through Black Canyon's site to uncover your future home in Phoenix! Find luxury apartments that elevate your lifestyle. Check out our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Black Canyon Luxury Apartments",
  "property_seo_description_thankyou": "Thank you for your inquiry! Your path to luxury living at Black Canyon Apartments in Phoenix starts here—our team will connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793679927315",
  "amenities": [
    {
      "id": "custom_7dda9101-3eb1-4eff-820d-03e2297e1528",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Heated Resort-Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a93862f7-8ebe-4bc3-8142-92cd99b8ab4a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park with Agility Equipment and Wash Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e895c00-4656-4d40-acbb-4968526050c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Community Clubhouse with Pool Table and Lounge Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db101f44-233c-4bd1-97d6-83b822e6c9d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Entry",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fd6237a-d8a4-4e2f-8e52-ec3b7f6b5649",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Cabanas & Sun Deck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d8ddf57-0566-4529-bdfc-93323db56de3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Entertainment Pavilion",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a688ce4e-4102-499a-8fa8-cd9edf1f295d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center with Co-Working Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae9b7d7b-e779-4b60-bf69-49b594c5529a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29fe3eee-daca-425a-bd96-5647dc4b2464",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Package Acceptance System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06a82015-ecaa-4886-be55-e364b1b9fe07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c49de540-1e56-4e7e-88ef-f748c7519419",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Access to I-17 and Major Employers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bcc04e22-69cd-4c67-b1ae-5b1a7efd2368",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_151f8edd-4c8c-41e4-8558-11a255e8e6d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_342350cc-00d1-4a68-9be6-5b83c364d7f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bdbdb12-937e-407c-a26a-d3cd4b5c4f23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood-Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c2d59b4-b7d5-4feb-941b-2790980413b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e061fbe-a328-4072-87f7-72d798cce98d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d982c6e-546f-4fb4-8a3c-de326c1a1d5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Islands*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_610f3b9e-ba3a-4945-a1ab-57ed8480075b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Windows for Natural Light",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bef0e268-5e03-42f7-b3fb-d7fe12d5df6c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Attached and Detached Garage Options*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_191e2548-fd71-4124-8d4b-f7f1ce7cd8aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Pantry Storage*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_462926b0-5d90-4800-932a-d8e52138f45e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans in Living Rooms & Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8e5cd491-fc3a-4875-96cf-0ac3ea536d19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-c352-7539-a31e-04c8492d5834.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex exterior with surrounding desert landscape.",
        "public_id": "01a15725-c352-7539-a31e-04c8492d5834",
        "storage_key": "property/6767906449167563/01a15725-c352-7539-a31e-04c8492d5834.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Sprawling aerial view of a modern apartment complex, showcasing its architecture against a backdrop of desert hills and clear blue sky.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex exterior with surrounding desert landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f2e4e01-b201-4be6-a751-c7e1981b7e98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-e2d7-77b7-9d87-1ed0cc11b0d3.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with yellow sofas, accent chairs, and a large wall-mounted TV, overlooking an outdoor patio.",
        "public_id": "01a15725-e2d7-77b7-9d87-1ed0cc11b0d3",
        "storage_key": "property/6767906449167563/01a15725-e2d7-77b7-9d87-1ed0cc11b0d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed resident lounge, featuring comfortable seating and a large TV, perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Stylish lounge area with yellow sofas, accent chairs, and a large wall-mounted TV, overlooking an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76931cac-d3ff-4490-bb2e-3fc8ca433b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-d954-70ed-87de-ef5bd0fb4076.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and a bar.",
        "public_id": "01a15725-d954-70ed-87de-ef5bd0fb4076",
        "storage_key": "property/6767906449167563/01a15725-d954-70ed-87de-ef5bd0fb4076.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the community lounge with a billiards table and bar area, perfect for entertaining guests or relaxing.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, seating, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4428c84d-91b6-4e90-b7e2-83e4a6df23e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-da3e-74ce-be9d-0356c40fc479.webp",
      "image_media": {
        "alt_text": "Modern conference room with a long table and chairs, large windows, and abstract wall art.",
        "public_id": "01a15725-da3e-74ce-be9d-0356c40fc479",
        "storage_key": "property/6767906449167563/01a15725-da3e-74ce-be9d-0356c40fc479.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Impress your colleagues or clients in our stylish conference room, equipped with a large table and comfortable seating, perfect for meetings and presentations.",
      "link": "",
      "alt_text": "Modern conference room with a long table and chairs, large windows, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_715368a6-c311-4b1c-9130-9e84b37c0ebd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15726-0229-711d-8edd-4986b2f891dc.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and benches.",
        "public_id": "01a15726-0229-711d-8edd-4986b2f891dc",
        "storage_key": "property/6767906449167563/01a15726-0229-711d-8edd-4986b2f891dc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our modern fitness center, equipped with everything you need for a complete workout.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio machines, weight machines, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6f10909-ca10-4201-b8bb-f01142e16d60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-fcb7-76b9-ba4f-1e56e6b10052.webp",
      "image_media": {
        "alt_text": "Spin bikes and a barre in a fitness studio with mirrors and TVs.",
        "public_id": "01a15725-fcb7-76b9-ba4f-1e56e6b10052",
        "storage_key": "property/6767906449167563/01a15725-fcb7-76b9-ba4f-1e56e6b10052.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring spin bikes, a barre for stretching, and large mirrors for your workout.",
      "link": "",
      "alt_text": "Spin bikes and a barre in a fitness studio with mirrors and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f10621e-6dfe-4962-8163-6d4ea803978e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-dbe9-7204-80c5-f36f94c3906a.webp",
      "image_media": {
        "alt_text": "Package locker system in apartment building hallway.",
        "public_id": "01a15725-dbe9-7204-80c5-f36f94c3906a",
        "storage_key": "property/6767906449167563/01a15725-dbe9-7204-80c5-f36f94c3906a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure package locker system for residents. Conveniently receive your deliveries at your convenience.",
      "link": "",
      "alt_text": "Package locker system in apartment building hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76bd14bc-98b8-49f5-943a-3d14bc1af15d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15726-0351-753e-ab81-6bf183d5c629.webp",
      "image_media": {
        "alt_text": "Pet spa with a large stainless steel tub and a painting of a dog wearing a cowboy hat.",
        "public_id": "01a15726-0351-753e-ab81-6bf183d5c629",
        "storage_key": "property/6767906449167563/01a15726-0351-753e-ab81-6bf183d5c629.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Groom your furry friends in our convenient pet spa, featuring a professional grooming tub and stylish decor.",
      "link": "",
      "alt_text": "Pet spa with a large stainless steel tub and a painting of a dog wearing a cowboy hat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6a03297-49b3-41c7-837e-b133454ddec3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-af54-7732-ab49-5b0d0bd7e190.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and lounge area with palm trees, surrounded by modern apartment buildings.",
        "public_id": "01a15725-af54-7732-ab49-5b0d0bd7e190",
        "storage_key": "property/6767906449167563/01a15725-af54-7732-ab49-5b0d0bd7e190.webp",
        "width": 2822,
        "height": 1881
      },
      "title": "Community",
      "description": "Enjoy resort-style living with a sparkling swimming pool and ample lounge seating, perfect for relaxing under the sun. Surrounded by modern architecture and lush landscaping, this community offers a vibrant atmosphere.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and lounge area with palm trees, surrounded by modern apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77728308-0abf-4d99-999b-50c40d49e63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-ec7b-76b8-ba68-efda1c5d6ce6.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex pool with palm trees and lounge chairs",
        "public_id": "01a15725-ec7b-76b8-ba68-efda1c5d6ce6",
        "storage_key": "property/6767906449167563/01a15725-ec7b-76b8-ba68-efda1c5d6ce6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Enjoy the California sun and make a splash in this beautiful oasis.",
      "link": "",
      "alt_text": "Luxury apartment complex pool with palm trees and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b171c923-a499-4ac5-8976-ef87ef9c0dc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15726-0820-761d-a96e-6642989ad5a4.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and dining area with two grills and a large communal table.",
        "public_id": "01a15726-0820-761d-a96e-6642989ad5a4",
        "storage_key": "property/6767906449167563/01a15726-0820-761d-a96e-6642989ad5a4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our state-of-the-art outdoor grilling stations and spacious communal seating area, perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor grilling and dining area with two grills and a large communal table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aea5f1d7-9720-4837-92da-94a4a03afecd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-ea50-761d-ad7a-37c4680073da.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with tables, chairs, bar, and TV.",
        "public_id": "01a15725-ea50-761d-ad7a-37c4680073da",
        "storage_key": "property/6767906449167563/01a15725-ea50-761d-ad7a-37c4680073da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this communal lounge space, complete with comfortable seating, a bar area perfect for entertaining, and a television for your viewing pleasure.",
      "link": "",
      "alt_text": "Outdoor lounge area with tables, chairs, bar, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6625e50-725e-46c5-a728-b7d05b0adfb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-e320-707d-9233-521b5b884721.webp",
      "image_media": {
        "alt_text": "Modern outdoor seating area with a fire pit and built-in benches.",
        "public_id": "01a15725-e320-707d-9233-521b5b884721",
        "storage_key": "property/6767906449167563/01a15725-e320-707d-9233-521b5b884721.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our modern outdoor lounge area, featuring a stylish fire pit and comfortable built-in seating, perfect for enjoying cool evenings.",
      "link": "",
      "alt_text": "Modern outdoor seating area with a fire pit and built-in benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55076404-d25e-46d7-9345-e9773cb4142f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-f11d-7663-ab73-abb8b3addbfa.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with cornhole, seating, umbrellas, and palm trees.",
        "public_id": "01a15725-f11d-7663-ab73-abb8b3addbfa",
        "storage_key": "property/6767906449167563/01a15725-f11d-7663-ab73-abb8b3addbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, complete with comfortable seating, shade umbrellas, and fun games like cornhole. Enjoy the resort-style ambiance with lush landscaping and palm trees.",
      "link": "",
      "alt_text": "Outdoor lounge area with cornhole, seating, umbrellas, and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db66038b-c475-4810-8463-17fe94650d35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-ef1d-7069-9966-63697b6b0f0a.webp",
      "image_media": {
        "alt_text": "Pet-friendly dog park with artificial turf and benches.",
        "public_id": "01a15725-ef1d-7069-9966-63697b6b0f0a",
        "storage_key": "property/6767906449167563/01a15725-ef1d-7069-9966-63697b6b0f0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated dog park for your furry friends. Features artificial turf for easy maintenance and benches for relaxation.",
      "link": "",
      "alt_text": "Pet-friendly dog park with artificial turf and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4224f079-72d5-42ab-9a9e-d2ddd58b190c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-daec-752f-bc8f-8fc0f0343891.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
        "public_id": "01a15725-daec-752f-bc8f-8fc0f0343891",
        "storage_key": "property/6767906449167563/01a15725-daec-752f-bc8f-8fc0f0343891.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a large granite island with bar seating, sleek white cabinetry, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8868933-0e79-4153-810d-5189069bb435",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-b34a-71f2-9533-953e801d08e4.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with white cabinets, stainless steel appliances, island with bar stools, and a white sofa.",
        "public_id": "01a15725-b34a-71f2-9533-953e801d08e4",
        "storage_key": "property/6767906449167563/01a15725-b34a-71f2-9533-953e801d08e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with ample cabinet space, stainless steel appliances, and a breakfast bar, flowing seamlessly into a comfortable living room with stylish seating and decor.",
      "link": "",
      "alt_text": "Modern living room and kitchen with white cabinets, stainless steel appliances, island with bar stools, and a white sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_158b39d7-8f49-40d7-a54f-264a20f73443",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-bde0-70a2-b6d1-67761cd1da67.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plush pillows, and a bedside table.",
        "public_id": "01a15725-bde0-70a2-b6d1-67761cd1da67",
        "storage_key": "property/6767906449167563/01a15725-bde0-70a2-b6d1-67761cd1da67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant decor, and a tranquil ambiance.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, plush pillows, and a bedside table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a02a2d6-b95d-4bff-8114-eb5c6a3fac57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-b33a-7178-b700-f6675d359af7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in closet, and glass shower.",
        "public_id": "01a15725-b33a-7178-b700-f6675d359af7",
        "storage_key": "property/6767906449167563/01a15725-b33a-7178-b700-f6675d359af7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with granite countertops, a walk-in closet, and a glass-enclosed shower. Perfect for a luxurious start to your day.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, walk-in closet, and glass shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a140c83b-8a09-4872-bae3-a0b160423dfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/01a15725-b284-75bd-9ffa-ef6c77407dba.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed and en suite bathroom.",
        "public_id": "01a15725-b284-75bd-9ffa-ef6c77407dba",
        "storage_key": "property/6767906449167563/01a15725-b284-75bd-9ffa-ef6c77407dba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed and access to a modern en suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed and en suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2037a914-53b8-49b5-a92d-ae26411d3321",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Drip 'N' Munch Cafe",
      "poi_type": "Restaurants",
      "poi_address": "711 E Carefree Hwy #109, Phoenix, AZ 85085, USA",
      "poi_short_description": "Informal eatery specializing in coffee drinks plus bagels and sandwiches (including gluten-free versions).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c9d4-718a-8b2d-39d9464f4582.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c9d4-718a-8b2d-39d9464f4582",
        "storage_key": "property/6767906449167563/019f6c49-c9d4-718a-8b2d-39d9464f4582.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://dripnmunch.cafe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8256182199030485179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drip-n-munch-cafe",
      "poi_latitude": "33.797732",
      "poi_longitude": "-112.0640552",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-582-9578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-092f-777d-9ba6-b9b5d23c704e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-092f-777d-9ba6-b9b5d23c704e",
        "storage_key": "property/6767906449167563/019f6c4a-092f-777d-9ba6-b9b5d23c704e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJoR2kuERjK4cRu5AdhvfZk3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fb6cd849-2a1f-4ac9-9a8a-ba179eea970f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Over Easy",
      "poi_type": "Restaurants",
      "poi_address": "2965 W Dove Valley Rd #500, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ce11-7759-80a7-acd9f008cadf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ce11-7759-80a7-acd9f008cadf",
        "storage_key": "property/6767906449167563/019f6c49-ce11-7759-80a7-acd9f008cadf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eatatovereasy.com/locations/dove-valley-rd/?utm_source=Google+Business+Profile&utm_medium=Website+Link&utm_campaign=Local+SEO",
      "poi_directions_map_url": "https://maps.google.com/?cid=10995306490480725128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "over-easy",
      "poi_latitude": "33.7825936",
      "poi_longitude": "-112.123053",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-597-6137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoy_RVSdjK4cRiIymWf8sl5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ec715938-2686-4add-947d-1d724ecd9dc1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Nekter Juice Bar",
      "poi_type": "Restaurants",
      "poi_address": "2730 W Dove Valley Rd Ste 110, Phoenix, AZ 85085, USA",
      "poi_short_description": "Local juice-bar chain offering specialty drinks, cleanses & health-conscious snacks.",
      "poi_long_description": "Local juice-bar chain offering specialty drinks, cleanses & health-conscious snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c8ec-721c-9ce5-a1436f6dbc14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c8ec-721c-9ce5-a1436f6dbc14",
        "storage_key": "property/6767906449167563/019f6c49-c8ec-721c-9ce5-a1436f6dbc14.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.nekterjuicebar.com/ll/us/az/phoenix/2730-w-dove-valley-road/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3135812849775525135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nekter-juice-bar",
      "poi_latitude": "33.7843125",
      "poi_longitude": "-112.1182841",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-248-6997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_HV4dljK4cRD735MCylhCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_f9db34f4-e41a-4e8d-a18e-19beac7789ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "LIMóN Urban Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2750 W Dove Valley Rd STE 190 190, Phoenix, AZ 85085, USA",
      "poi_short_description": "Tacos & margaritas offered in a cheerful, laid-back restaurant with TVs & outdoor seating.",
      "poi_long_description": "Tacos & margaritas offered in a cheerful, laid-back restaurant with TVs & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c4a2-736f-8e6a-80ea95649e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c4a2-736f-8e6a-80ea95649e00",
        "storage_key": "property/6767906449167563/019f6c49-c4a2-736f-8e6a-80ea95649e00.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://limonurbankitchen.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9569191849164088561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limn-urban-kitchen",
      "poi_latitude": "33.7859827",
      "poi_longitude": "-112.1184298",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-466-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBxGdrvJjK4cR8ST9fEmZzIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4ccb6066-ed6c-4d36-a560-85feaf5c8337",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Roadrunner Restaurant & Saloon",
      "poi_type": "Restaurants",
      "poi_address": "47801 N Black Canyon Hwy, New River, AZ 85087, USA",
      "poi_short_description": "American fare in a country atmosphere with mechanical & live bull riding, karaoke & live bands.",
      "poi_long_description": "American fare in a country atmosphere with mechanical & live bull riding, karaoke & live bands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c659-734b-af90-dd1943732be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c659-734b-af90-dd1943732be2",
        "storage_key": "property/6767906449167563/019f6c49-c659-734b-af90-dd1943732be2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.roadrunnerrestaurantandsaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=708254980752938802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roadrunner-restaurant--saloon",
      "poi_latitude": "33.9188751",
      "poi_longitude": "-112.1402514",
      "poi_miles_from_property": "16.9",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 623-465-9903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-0938-755f-a4a3-f648e88b6f47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-0938-755f-a4a3-f648e88b6f47",
        "storage_key": "property/6767906449167563/019f6c4a-0938-755f-a4a3-f648e88b6f47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy49UCCcLIcRMhcuCic61Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_7fd00246-751f-41d9-9393-cc1f2e40613e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Mellow Mushroom Phoenix",
      "poi_type": "Restaurants",
      "poi_address": "2490 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_long_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c6bd-74cc-b137-4559fb854be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c6bd-74cc-b137-4559fb854be3",
        "storage_key": "property/6767906449167563/019f6c49-c6bd-74cc-b137-4559fb854be3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mellowmushroom.com/locations/az/phoenix/2490-w-happy-valley-rd?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4631916482501116469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellow-mushroom-phoenix",
      "poi_latitude": "33.7134539",
      "poi_longitude": "-112.1139689",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-580-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwgTI5ZlK4cRNYLB-H_fR0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d3eab513-8386-4630-b39b-3b39e69b46c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2370 W Happy Valley Rd Ste 1069, Phoenix, AZ 85085, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c582-71ee-a862-e817061f5950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c582-71ee-a862-e817061f5950",
        "storage_key": "property/6767906449167563/019f6c49-c582-71ee-a862-e817061f5950.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/az/phoenix/2370-west-happy-valley-rd?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601921&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=8688537886348350040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "33.7145721",
      "poi_longitude": "-112.1108204",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-414-4885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-092f-777d-9ba6-b9b5d23c704e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-092f-777d-9ba6-b9b5d23c704e",
        "storage_key": "property/6767906449167563/019f6c4a-092f-777d-9ba6-b9b5d23c704e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJV3X8L5ZlK4cRWBJRfSzjk3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5c012b87-0415-442a-ac60-347e0468a47e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Sauce Pizza & Wine",
      "poi_type": "Restaurants",
      "poi_address": "2470 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Local Italian chain serving pizza, pasta & panini, plus beer & wine, in a casual setting.",
      "poi_long_description": "Local Italian chain serving pizza, pasta & panini, plus beer & wine, in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c9e2-731d-b3ac-8a44324e0081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c9e2-731d-b3ac-8a44324e0081",
        "storage_key": "property/6767906449167563/019f6c49-c9e2-731d-b3ac-8a44324e0081.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.saucepizzaandwine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16593160879391790227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sauce-pizza--wine",
      "poi_latitude": "33.7148264",
      "poi_longitude": "-112.1130493",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-414-4866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXe62r1lK4cRk1QOzee_RuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a375a4e2-bc3b-45a8-9065-8d4fa96af713",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Pita Jungle",
      "poi_type": "Restaurants",
      "poi_address": "2530 W Happy Valley Rd Ste 1261, Phoenix, AZ 85085, USA",
      "poi_short_description": "Chain for health-oriented Mediterranean dishes, including lots of veggie options, in sleek environs.",
      "poi_long_description": "Chain for health-oriented Mediterranean dishes, including lots of veggie options, in sleek environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c6fc-770a-9303-2636cdabbfdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c6fc-770a-9303-2636cdabbfdb",
        "storage_key": "property/6767906449167563/019f6c49-c6fc-770a-9303-2636cdabbfdb.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://pitajungle.com/locations/norterra/?utm_source=google&utm_medium=organic&utm_campaign=Norterra&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=18168688349619089599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pita-jungle",
      "poi_latitude": "33.7152639",
      "poi_longitude": "-112.1133056",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-587-5572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16un4r1lK4cRv_DSycolJPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_b4884578-78d5-4ea0-aca5-193b26a7ac8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2600 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-3550-72d2-b0c6-ae853f5a356a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-3550-72d2-b0c6-ae853f5a356a",
        "storage_key": "property/6767906449167563/019f6c46-3550-72d2-b0c6-ae853f5a356a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arizona/happy-valley?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6446391845365507556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.7148854",
      "poi_longitude": "-112.1158096",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-434-4640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ33s15r9lK4cR5GX8mTovdlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_3a1244be-d584-4e7c-b346-32a6dad973ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Greek Pita",
      "poi_type": "Restaurants",
      "poi_address": "2501 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Kebabs, falafel & gyros round out the menu at this Greek fast-food restaurant with value meals.",
      "poi_long_description": "Kebabs, falafel & gyros round out the menu at this Greek fast-food restaurant with value meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-c65c-76b0-862f-fffd54d04895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-c65c-76b0-862f-fffd54d04895",
        "storage_key": "property/6767906449167563/019f6c49-c65c-76b0-862f-fffd54d04895.webp",
        "width": 607,
        "height": 1280
      },
      "poi_business_url": "http://www.thegreekpita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6662522208037215206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greek-pita",
      "poi_latitude": "33.7110837",
      "poi_longitude": "-112.1114334",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-587-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-568e-7798-9131-557ecf973dc5",
        "storage_key": "property/6767906449167563/019f6c46-568e-7798-9131-557ecf973dc5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbyKUKnJlK4cR5ps1DqYIdlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_284681d8-d027-4243-b0d3-511e7f2744a2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6550 W Happy Valley Rd, Glendale, AZ 85310, USA",
      "poi_short_description": "Retailer featuring groceries, baked goods, frozen food and produce as well as a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-cdc4-74cf-aed5-d123574c997e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-cdc4-74cf-aed5-d123574c997e",
        "storage_key": "property/6767906449167563/019f6c49-cdc4-74cf-aed5-d123574c997e.webp",
        "width": 1280,
        "height": 558
      },
      "poi_business_url": "https://www.walmart.com/store/4233-phoenix-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13368594134477226404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "33.7137957",
      "poi_longitude": "-112.2013001",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-566-9754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-b0f1f27844f6",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Rc_Uq9nK4cRpMHiE4nJhrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ecc43a47-f575-4d7d-8682-68ce5b8b935c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Fry's Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 W Dove Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-3452-7770-a2d2-4dec071945cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-3452-7770-a2d2-4dec071945cd",
        "storage_key": "property/6767906449167563/019f6c46-3452-7770-a2d2-4dec071945cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.frysfood.com/stores/grocery/az/phoenix/north-valley-pkwy-dove-valley/660/00694?cid=loc_66000694_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3829872201186224928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frys-marketplace",
      "poi_latitude": "33.7860527",
      "poi_longitude": "-112.1194482",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-994-6230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-b0f1f27844f6",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBxGdrvJjK4cRICvZtnlwJjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_99a551df-e517-4a41-b42f-babc964f4283",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3610 W Anthem Way, Anthem, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-cda9-72f0-bcba-c85e9d3de601.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-cda9-72f0-bcba-c85e9d3de601",
        "storage_key": "property/6767906449167563/019f6c49-cda9-72f0-bcba-c85e9d3de601.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/phoenix-az-pharmacies/3610-w-anthem-way-phoenix-az-85086/storeid=9340?WT.mc_id=LS_GOOGLE_RX_9340",
      "poi_directions_map_url": "https://maps.google.com/?cid=14800025755045712291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.8662783",
      "poi_longitude": "-112.1358957",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 623-551-4299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-094d-7664-b747-0f342d36585e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-094d-7664-b747-0f342d36585e",
        "storage_key": "property/6767906449167563/019f6c4a-094d-7664-b747-0f342d36585e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx7bjbfudLIcRo9EhpAJBZM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ca48d70f-619f-4062-b719-48ae08426d59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2411 W Anthem Way #101, Anthem, AZ 85086, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d191-74a6-b3ce-77f5ac08ebfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d191-74a6-b3ce-77f5ac08ebfe",
        "storage_key": "property/6767906449167563/019f6c49-d191-74a6-b3ce-77f5ac08ebfe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2411+w+anthem+way-anthem-az-85086/id=7516",
      "poi_directions_map_url": "https://maps.google.com/?cid=9004713387243560644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.8588592",
      "poi_longitude": "-112.1116873",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-551-2465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9Iv83ZiK4cRxF7b3h0r93w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d9c42bee-a048-4445-95bf-de1c776be5d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4435 W Anthem Way, Anthem, AZ 85086, USA",
      "poi_short_description": "Wide-ranging retailer selling electronics appliances furniture houseware electronics, toys, home décor, groceries, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-cf9a-708f-b815-e838aff2d7f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-cf9a-708f-b815-e838aff2d7f9",
        "storage_key": "property/6767906449167563/019f6c49-cf9a-708f-b815-e838aff2d7f9.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5329-anthem-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2109165682688417265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.8695449",
      "poi_longitude": "-112.1547546",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-551-6314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56b4-730f-9259-74d621f6d66b",
        "storage_key": "property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ21PjRhKeLIcR8V0WeQNDRR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9bdf913f-084b-4173-a9e8-8e230ba2656f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "34750 N North Vly Pkwy, Phoenix, AZ 85086, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-cf4e-718f-8941-136faaac13f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-cf4e-718f-8941-136faaac13f0",
        "storage_key": "property/6767906449167563/019f6c49-cf4e-718f-8941-136faaac13f0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sprouts.com/store/az/phoenix/north-valley-pkwy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14794250597796578061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.7996082",
      "poi_longitude": "-112.1316828",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-956-6058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-b0f1f27844f6",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6po0gVjK4cRDYPGD4m8T80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0c061244-9d17-4931-9ec6-02a722dc6261",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Outlets North Phoenix",
      "poi_type": "Shopping & Retail",
      "poi_address": "4250 W Anthem Way, Phoenix, AZ 85086, USA",
      "poi_short_description": "Shopping outlet with global fashion brands, a food court, play area, splash pad & baby area.",
      "poi_long_description": "Shopping outlet with global fashion brands, a food court, play area, splash pad & baby area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d13a-7360-acdb-6e14be65bbfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d13a-7360-acdb-6e14be65bbfe",
        "storage_key": "property/6767906449167563/019f6c49-d13a-7360-acdb-6e14be65bbfe.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.northphoenixoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14739301369297447275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outlets-north-phoenix",
      "poi_latitude": "33.8736959",
      "poi_longitude": "-112.1496088",
      "poi_miles_from_property": "13.8",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-465-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56b4-730f-9259-74d621f6d66b",
        "storage_key": "property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_4FuIwyeLIcRayln0oCEjMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ae4ef33d-8e79-4c4f-8bf7-d2d537d15f26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Shops at Norterra",
      "poi_type": "Shopping & Retail",
      "poi_address": "2460 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "A collection of stores, eateries, services & a movie theater line the streets of this outdoor mall.",
      "poi_long_description": "A collection of stores, eateries, services & a movie theater line the streets of this outdoor mall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d021-73d4-802d-8fb044061bc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d021-73d4-802d-8fb044061bc2",
        "storage_key": "property/6767906449167563/019f6c49-d021-73d4-802d-8fb044061bc2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://theshopsatnorterra.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7466503832759776504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shops-at-norterra",
      "poi_latitude": "33.7141346",
      "poi_longitude": "-112.1116379",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-387-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56b4-730f-9259-74d621f6d66b",
        "storage_key": "property/6767906449167563/019f6c46-56b4-730f-9259-74d621f6d66b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkcW-6pdlK4cR-DS9Oa1Znmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_da122c8f-915a-4241-843e-9c223c7cc357",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Circle K | Gas Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3502 W Anthem Way, Phoenix, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d27d-710f-8d32-286c6b8d6a91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d27d-710f-8d32-286c6b8d6a91",
        "storage_key": "property/6767906449167563/019f6c49-d27d-710f-8d32-286c6b8d6a91.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/phoenix/3502-w-anthem-way/2709189?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14811264251812226093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k--gas-station",
      "poi_latitude": "33.8656029",
      "poi_longitude": "-112.1347384",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-551-9613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-0941-762f-9a69-fb30d1347a7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-0941-762f-9a69-fb30d1347a7a",
        "storage_key": "property/6767906449167563/019f6c4a-0941-762f-9a69-fb30d1347a7a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbVngM-dLIcRLaS1E10ujM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_52b60e70-411d-4daf-be8d-c2d6593724c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "3130 W Carefree Hwy, Phoenix, AZ 85086, USA",
      "poi_short_description": "Chain grocery store and deli featuring an in-store bakery and pick-up options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d3ee-71b8-9f9f-f8dda35670e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d3ee-71b8-9f9f-f8dda35670e3",
        "storage_key": "property/6767906449167563/019f6c49-d3ee-71b8-9f9f-f8dda35670e3.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.albertsons.com/az/phoenix/3130-w-carefree-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7249316339747581844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "33.7999586",
      "poi_longitude": "-112.1269997",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-582-4985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-b0f1f27844f6",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-b0f1f27844f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZEQlcNjK4cRlO8Wb82-mmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_067738f8-cfa7-483a-acd7-907947838f9c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Norterra Canyon School",
      "poi_type": "Education",
      "poi_address": "2200 W Maya Way, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d51a-712c-9b5a-1305ff2a6e9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d51a-712c-9b5a-1305ff2a6e9d",
        "storage_key": "property/6767906449167563/019f6c49-d51a-712c-9b5a-1305ff2a6e9d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://norterracanyon.dvusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6825544634180338020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norterra-canyon-school",
      "poi_latitude": "33.7304824",
      "poi_longitude": "-112.1068436",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-445-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX9_kCa5lK4cRZIHkdq40uV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cbaead79-32bc-4271-8e75-4f9e3d7e6ca8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Union Park School",
      "poi_type": "Education",
      "poi_address": "25700 N 21st Ave, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d5df-772a-a606-8cc10e8ee773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d5df-772a-a606-8cc10e8ee773",
        "storage_key": "property/6767906449167563/019f6c49-d5df-772a-a606-8cc10e8ee773.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dvusd.org/unionpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12387649619696651009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-park-school",
      "poi_latitude": "33.719071",
      "poi_longitude": "-112.1074359",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-445-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq9z108hlK4cRAYsFULLF6as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_df345a3f-bb1b-4751-ae64-774492fb8eef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Sonoran Foothills School",
      "poi_type": "Education",
      "poi_address": "32150 N N Foothills Dr, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d4ce-73ec-b362-94e325b33592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d4ce-73ec-b362-94e325b33592",
        "storage_key": "property/6767906449167563/019f6c49-d4ce-73ec-b362-94e325b33592.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sonoranfoothills.dvusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11661113730960809632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonoran-foothills-school",
      "poi_latitude": "33.7755211",
      "poi_longitude": "-112.1052819",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-445-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5aCKOnpkK4cRoF5ZsyeZ1KE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a9e7b76f-b1a2-48bb-82d4-5eead7310611",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Barry Goldwater High School",
      "poi_type": "Education",
      "poi_address": "2820 W Rose Garden Ln, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d72c-72e8-b398-5ea9b845e1b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d72c-72e8-b398-5ea9b845e1b0",
        "storage_key": "property/6767906449167563/019f6c49-d72c-72e8-b398-5ea9b845e1b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bghs.dvusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339566316622342208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barry-goldwater-high-school",
      "poi_latitude": "33.6778608",
      "poi_longitude": "-112.1187956",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-445-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Zygu0JvK4cRQGim6C_yPqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c409c85f-5cd2-4f3b-90e9-60153057c48a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Inspiration Mountain School",
      "poi_type": "Education",
      "poi_address": "5757 W Inspiration Mountain Pkwy, Phoenix, AZ 85083, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dvusd.org/InspirationMountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=13993858266129392311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inspiration-mountain-school",
      "poi_latitude": "33.7314429",
      "poi_longitude": "-112.1815329",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-376-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ49w1IjhnK4cRt2LOTfMrNMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_85b7a0c2-21dc-4778-8115-61e3da3b4214",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Stetson Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "25475 N Stetson Hills Loop, Phoenix, AZ 85083, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d5d5-76c8-8ae7-4aaa58b2dcb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d5d5-76c8-8ae7-4aaa58b2dcb1",
        "storage_key": "property/6767906449167563/019f6c49-d5d5-76c8-8ae7-4aaa58b2dcb1.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "http://dvusd.org/stetsonhills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2016134074880642059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stetson-hills-elementary-school",
      "poi_latitude": "33.717776",
      "poi_longitude": "-112.150806",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-445-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzRKvbnpmK4cRC0zSWEK_-hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8a00ab57-e478-47ba-a35d-392a3136ad92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Primrose School of North Phoenix",
      "poi_type": "Education",
      "poi_address": "28750 N Vly Pkwy, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d794-71a4-8c8c-0971711c5bc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d794-71a4-8c8c-0971711c5bc5",
        "storage_key": "property/6767906449167563/019f6c49-d794-71a4-8c8c-0971711c5bc5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.primroseschools.com/schools/north-phoenix/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788070557842282108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-north-phoenix",
      "poi_latitude": "33.7452243",
      "poi_longitude": "-112.1096025",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-900-2404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpX7qOBdlK4cRfBbGV-3r2_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_55176f5f-4147-4ba9-a11a-5368183fbbcd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "New River Elementary School",
      "poi_type": "Education",
      "poi_address": "48827 N Black Canyon Hwy, New River, AZ 85087, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://newriver.dvusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6244258148529823090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-river-elementary-school",
      "poi_latitude": "33.9260409",
      "poi_longitude": "-112.1404134",
      "poi_miles_from_property": "17.4",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 623-376-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbwfyLRycLIcRcl313LMPqFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_806d88b4-cbb3-4361-b956-0dc40cfbbf82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Diamond Canyon School",
      "poi_type": "Education",
      "poi_address": "40004 N Liberty Bell Way, Anthem, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dvusd.org/diamondcanyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=17198109985004491311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "diamond-canyon-school",
      "poi_latitude": "33.8485193",
      "poi_longitude": "-112.1003599",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 623-445-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj0AU8M9jK4cRL5JKcOn1q-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7d6eddc1-6b11-4eb8-beea-21cd9db1f3d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Gavilan Peak School",
      "poi_type": "Education",
      "poi_address": "2701 Memorial Dr, Anthem, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://gavilanpeak.dvusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4922330644610772992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gavilan-peak-school",
      "poi_latitude": "33.8558673",
      "poi_longitude": "-112.116487",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 623-445-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAfJxe3NiK4cRAHALQ6ShT0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a27ecac1-0804-4d06-90b1-81b30973c3b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Harkins Theatres Norterra",
      "poi_type": "Entertainment",
      "poi_address": "2550 W Happy Valley Rd, Phoenix, AZ 85085, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-d8a5-762a-9b45-c44ec9d14e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-d8a5-762a-9b45-c44ec9d14e46",
        "storage_key": "property/6767906449167563/019f6c49-d8a5-762a-9b45-c44ec9d14e46.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "https://harkins.com/theatres/norterra/?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10025570038053277169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-norterra",
      "poi_latitude": "33.7155162",
      "poi_longitude": "-112.1145687",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-582-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-0941-762f-9a69-f786fd119e0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-0941-762f-9a69-f786fd119e0e",
        "storage_key": "property/6767906449167563/019f6c4a-0941-762f-9a69-f786fd119e0e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdr3-JVlK4cR8Q339NT6IYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_4e8782f6-fd88-4762-92de-9dc0c85bb59e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Anthem Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "41703 N Gavilan Peak Pkwy, Anthem, AZ 85086, USA",
      "poi_short_description": "Sizable park with amenities such as a fishing pond, playground, sports facilities & miles of trails.",
      "poi_long_description": "Sizable park with amenities such as a fishing pond, playground, sports facilities & miles of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-da40-725f-b351-a727a568e3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-da40-725f-b351-a727a568e3e9",
        "storage_key": "property/6767906449167563/019f6c49-da40-725f-b351-a727a568e3e9.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.anthemcouncil.com/345/ACC-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6990397800341417182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anthem-community-park",
      "poi_latitude": "33.8592454",
      "poi_longitude": "-112.1351138",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-879-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQRbIvmdLIcR3qwFQMPhAmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_17c293e7-3416-401c-a7ff-5474b5952ea2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "North Valley Escape Room",
      "poi_type": "Entertainment",
      "poi_address": "42302 N Vision Way #104, Phoenix, AZ 85086, USA",
      "poi_short_description": "Puzzle-filled destination featuring themed rooms for birthdays, team building and other outings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-da48-71bd-a7ba-8c87c158d6bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-da48-71bd-a7ba-8c87c158d6bd",
        "storage_key": "property/6767906449167563/019f6c49-da48-71bd-a7ba-8c87c158d6bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northvalleyescaperoom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12726842051724327840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-valley-escape-room",
      "poi_latitude": "33.8682935",
      "poi_longitude": "-112.1519655",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-551-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1QU_w6eLIcRoDuIlWrTnrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_4ac7cc11-259c-4d60-8a2a-871e68688d42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Musical Theatre of Anthem",
      "poi_type": "Entertainment",
      "poi_address": "42201 N 41st Dr Ste. B100, Anthem, AZ 85086, USA",
      "poi_short_description": "Performing arts theater offering shows featuring youth and adult talent, plus educational opportunities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-da2b-72b4-accb-e4c4f2a86260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-da2b-72b4-accb-e4c4f2a86260",
        "storage_key": "property/6767906449167563/019f6c49-da2b-72b4-accb-e4c4f2a86260.webp",
        "width": 960,
        "height": 752
      },
      "poi_business_url": "http://www.musicaltheatreofanthem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11825818266151588367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musical-theatre-of-anthem",
      "poi_latitude": "33.8672425",
      "poi_longitude": "-112.1473284",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-336-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6Un6A6eLIcRD5JKpA6_HaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_f7dcca96-281b-4289-9ea2-6a5ae836b8dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Homeland Brew Co.",
      "poi_type": "Restaurants",
      "poi_address": "4225 W Fortune Dr Ste 100, Anthem, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-dc7b-700f-b350-cf9c7ed9e983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-dc7b-700f-b350-cf9c7ed9e983",
        "storage_key": "property/6767906449167563/019f6c49-dc7b-700f-b350-cf9c7ed9e983.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://homelandbrewco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10798102723478066905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland-brew-co",
      "poi_latitude": "33.86822610000001",
      "poi_longitude": "-112.1501729",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYEpmvhR-0IR2ZYWWTeR2pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_988dfda1-d81b-4f32-a25b-6c066b32bb8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Black Canyon Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "33955 Old Black Canyon Hwy, Black Canyon City, AZ 85324, USA",
      "poi_short_description": "Clean and pretty park featuring a preserve with a pond, short hiking trails, birds, and butterflies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-dc10-764b-8462-50b42d330579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-dc10-764b-8462-50b42d330579",
        "storage_key": "property/6767906449167563/019f6c49-dc10-764b-8462-50b42d330579.webp",
        "width": 693,
        "height": 1040
      },
      "poi_business_url": "https://blackcanyonheritagepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6190319458932617664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-canyon-heritage-park",
      "poi_latitude": "34.071015",
      "poi_longitude": "-112.151863",
      "poi_miles_from_property": "30",
      "poi_walking_minutes": "11 hours 21 mins",
      "poi_biking_minutes": "3 hours 7 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 623-374-5282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRrz2NaWLIcRwPHdC8Bu6FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_15b02eb7-8b71-432e-953e-5175af40c141",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Pioneer Living History Museum",
      "poi_type": "Entertainment",
      "poi_address": "3901 W Pioneer Rd, Phoenix, AZ 85086, USA",
      "poi_short_description": "History comes alive in this expansive re-creation of a Western town from Arizona's territorial days.",
      "poi_long_description": "History comes alive in this expansive re-creation of a Western town from Arizona's territorial days.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-399b-701d-afbf-0c0e0706d9a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-399b-701d-afbf-0c0e0706d9a6",
        "storage_key": "property/6767906449167563/019f6c46-399b-701d-afbf-0c0e0706d9a6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://pioneeraz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16946261880316616185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-living-history-museum",
      "poi_latitude": "33.8194972",
      "poi_longitude": "-112.1487449",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-465-1052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-5691-74bd-8530-e333e216f47f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-5691-74bd-8530-e333e216f47f",
        "storage_key": "property/6767906449167563/019f6c46-5691-74bd-8530-e333e216f47f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB53s_SliK4cR-d0DH2U3Les",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_01bbf677-58c7-4913-9ce0-51d67318e1e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Lake Pleasant Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "41835 North Castle Hot Springs Road, Morristown, AZ 85342, USA",
      "poi_short_description": "Expansive recreation area offering facilities for boating, fishing, camping, hiking & picnicking.",
      "poi_long_description": "Expansive recreation area offering facilities for boating, fishing, camping, hiking & picnicking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-de2b-7778-b40c-8dd516875827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-de2b-7778-b40c-8dd516875827",
        "storage_key": "property/6767906449167563/019f6c49-de2b-7778-b40c-8dd516875827.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maricopacountyparks.net/park-locator/lake-pleasant-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2794981028348262704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-pleasant-regional-park",
      "poi_latitude": "33.864488",
      "poi_longitude": "-112.3172788",
      "poi_miles_from_property": "21.8",
      "poi_walking_minutes": "7 hours 58 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 928-501-1710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19gYSe2hLIcRMHmn1G_EySY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ea14afd5-e180-4837-9ee9-61047bb2bbec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "My Play Place",
      "poi_type": "Entertainment",
      "poi_address": "4250 W Anthem Way Ste 665, Anthem, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-de70-72b4-b9fb-d33aed5df67f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-de70-72b4-b9fb-d33aed5df67f",
        "storage_key": "property/6767906449167563/019f6c49-de70-72b4-b9fb-d33aed5df67f.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://myplayplaceaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11962560284449589259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-play-place",
      "poi_latitude": "33.8738279",
      "poi_longitude": "-112.1493964",
      "poi_miles_from_property": "13.9",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-818-2441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdec94mGfLIcRC0jQxjKNA6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_aad645cf-f9b6-421e-b834-fa84c202182f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "HonorHealth Sonoran Crossing Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "33400 N 32nd Ave, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-4444-7156-bd46-dc013d70bfda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-4444-7156-bd46-dc013d70bfda",
        "storage_key": "property/6767906449167563/019f6c46-4444-7156-bd46-dc013d70bfda.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.honorhealth.com/locations/emergency/sonoran-health-and-emergency-center?utm_source=GMB&utm_medium=local&utm_campaign=Sonoran_Health_And_Emergency_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3182458948059905139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honorhealth-sonoran-crossing-medical-center",
      "poi_latitude": "33.7853404",
      "poi_longitude": "-112.1301787",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-683-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-5694-7114-a2d6-1151d888dae6",
        "storage_key": "property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJiUyepu9jK4cRc7xfR41dKiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_fca3db6c-7bc9-4c70-a9f1-d3db132dfc03",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "HonorHealth Deer Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19829 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-43e7-773f-b262-1c2b9b54cfdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-43e7-773f-b262-1c2b9b54cfdf",
        "storage_key": "property/6767906449167563/019f6c46-43e7-773f-b262-1c2b9b54cfdf.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/deer-valley-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=Valley_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15230205930965625593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honorhealth-deer-valley-medical-center",
      "poi_latitude": "33.6655324",
      "poi_longitude": "-112.1164943",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-879-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-5694-7114-a2d6-1151d888dae6",
        "storage_key": "property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTTNBRvK4cR-epA45mPXNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0a49a6fd-6165-4b46-8bd2-b95740ad1213",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "NextCare Urgent Care, Phoenix (N North Valley Pkwy)",
      "poi_type": "Health and Wellness",
      "poi_address": "34640 N Vly Pkwy A104, Phoenix, AZ 85086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e08f-759c-b04d-8eb24caa4fa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e08f-759c-b04d-8eb24caa4fa6",
        "storage_key": "property/6767906449167563/019f6c49-e08f-759c-b04d-8eb24caa4fa6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nextcare.com/locations/az/tramonto/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=tramonto",
      "poi_directions_map_url": "https://maps.google.com/?cid=15024208417560933737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-phoenix-n-north-valley-pkwy",
      "poi_latitude": "33.7989826",
      "poi_longitude": "-112.1314982",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-381-4858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_kIC45jK4cRaTUnQPS1gNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f5cb56f2-5742-4f06-8c8a-a3d52a978560",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "28635 N North Vly Pkwy, Phoenix, AZ 85085, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e2ca-752b-8bc6-a60c2b0e6205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e2ca-752b-8bc6-a60c2b0e6205",
        "storage_key": "property/6767906449167563/019f6c49-e2ca-752b-8bc6-a60c2b0e6205.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/phoenix-az-pharmacies/28635-n-north-valley-parkway-phoenix-az-85085/storeid=10150?WT.mc_id=LS_GOOGLE_FS_10150",
      "poi_directions_map_url": "https://maps.google.com/?cid=11610781660133119409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7418383",
      "poi_longitude": "-112.1067005",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-582-9207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wcT6U9kK4cRsdXaQGfIIaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_be6f4f76-161a-4c52-a8fe-7eb5cc5031b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 W Happy Valley Rd Ste 34, Phoenix, AZ 85085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-deda-77c0-a4ee-b4a2e91d250c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-deda-77c0-a4ee-b4a2e91d250c",
        "storage_key": "property/6767906449167563/019f6c49-deda-77c0-a4ee-b4a2e91d250c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/5190-phoenix-az/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2297132097212079146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.7087117",
      "poi_longitude": "-112.112403",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-780-5713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-094d-7664-b747-0f342d36585e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-094d-7664-b747-0f342d36585e",
        "storage_key": "property/6767906449167563/019f6c4a-094d-7664-b747-0f342d36585e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLx6omJZlK4cRKlx5wHgN4R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8aa99c81-7209-4e9b-a6b1-9a5e2d0d5629",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Mountainside Fitness Happy Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 W Happy Valley Rd Suite 30, Phoenix, AZ 85085, USA",
      "poi_short_description": "Large chain fitness center with a wide range of equipment, classes and staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-3d28-714a-99a9-d3ca4eadef18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-3d28-714a-99a9-d3ca4eadef18",
        "storage_key": "property/6767906449167563/019f6c46-3d28-714a-99a9-d3ca4eadef18.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/happy-valley/?utm_source=GMB&utm_medium=Local&utm_campaign=HappyValley&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=6868094223304764676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountainside-fitness-happy-valley",
      "poi_latitude": "33.7085901",
      "poi_longitude": "-112.1149277",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-601-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiz7_bJRlK4cRBC3-r05fUF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3a913d56-f249-407b-8b8a-b9b05ba937e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "2450 W Happy Valley Rd #1149, Phoenix, AZ 85085, USA",
      "poi_short_description": "Pilates studio offering group classes that use state-of-the-art equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e149-72e8-946f-aac1c7bbe98b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e149-72e8-946f-aac1c7bbe98b",
        "storage_key": "property/6767906449167563/019f6c49-e149-72e8-946f-aac1c7bbe98b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/norterra/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5670121229385449853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "33.7144563",
      "poi_longitude": "-112.11198",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-312-8505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Whn-F1lK4cRfcHrbjdRsE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_367501ed-3b5d-474e-9654-75fe292f70d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Tusk Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "23910 N 19th Ave #18, Phoenix, AZ 85085, USA",
      "poi_short_description": "Friendly CrossFit gym providing classes along with nutrition coaching.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e2d9-70ce-81b7-d02701ca342a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e2d9-70ce-81b7-d02701ca342a",
        "storage_key": "property/6767906449167563/019f6c49-e2d9-70ce-81b7-d02701ca342a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.tuskathleticsaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6827480249833913211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tusk-athletics",
      "poi_latitude": "33.7032928",
      "poi_longitude": "-112.1006317",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-267-9211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2evXkIRlK4cRe3tYGh0VwF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a3e48411-4de3-4a1b-8914-9b78f1a549a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Body Alive Moon Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "350 E Bell Rd #10, Phoenix, AZ 85022, USA",
      "poi_short_description": "Welcoming studio offering yoga, Pilates, fitness and cardio classes, as well as dance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e63e-7040-8389-0bdf619ac65d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e63e-7040-8389-0bdf619ac65d",
        "storage_key": "property/6767906449167563/019f6c49-e63e-7040-8389-0bdf619ac65d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bodyalivefitness.com/location/body-alive-moon-valley/?utm_source=GoogleBusinessProfile&utm_medium=Website&utm_campaign=MapLabs",
      "poi_directions_map_url": "https://maps.google.com/?cid=16457690365607185450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "body-alive-moon-valley",
      "poi_latitude": "33.6416544",
      "poi_longitude": "-112.0687638",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-688-6511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBbGyCoNvK4cRKoxi4TB2ZeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2f3c0b59-920f-40b1-b772-c17931c9202b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Desert Hills Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "705 W Carefree Hwy, Phoenix, AZ 85085, USA",
      "poi_short_description": "Scenic hiking trails through desert terrain, along with mountain-biking opportunities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e6a6-739f-811f-e0d4e44d1012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e6a6-739f-811f-e0d4e44d1012",
        "storage_key": "property/6767906449167563/019f6c49-e6a6-739f-811f-e0d4e44d1012.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/sonoran-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=7305966893984453740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desert-hills-trailhead",
      "poi_latitude": "33.7982211",
      "poi_longitude": "-112.0844191",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-ad08b2d18ef0",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74o-9nFjK4cRbBS1cC4CZGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_20d0ca4f-dc9c-42d1-80e5-1fc487bbf98f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Apache Wash Trail Head",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 E Sonoran Desert Dr, Phoenix, AZ 85085, USA",
      "poi_short_description": "Public area offering a variety of hiking trails with scenic views for all skill levels, plus mountain biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-4f2c-747f-842d-20aa0c8285d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-4f2c-747f-842d-20aa0c8285d9",
        "storage_key": "property/6767906449167563/019f6c46-4f2c-747f-842d-20aa0c8285d9.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/sonoran-preserve/trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=1621773862150703359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apache-wash-trail-head",
      "poi_latitude": "33.763965",
      "poi_longitude": "-112.049702",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-ad08b2d18ef0",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ595X7Y17K4cR_4iBL7yygRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_f87ed79b-ca50-41a9-b3a2-81cb86f36509",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Desert Vista Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1901 W Desert Vista Trail, Phoenix, AZ 85085, USA",
      "poi_short_description": "Popular hiking area with gorgeous views, a well-maintained trail, and a big hawk's nest.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e58b-7708-bc9b-d60a9e5ecd86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e58b-7708-bc9b-d60a9e5ecd86",
        "storage_key": "property/6767906449167563/019f6c49-e58b-7708-bc9b-d60a9e5ecd86.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/sonoran-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=4979770671228364469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desert-vista-trailhead",
      "poi_latitude": "33.7409985",
      "poi_longitude": "-112.0974085",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-495-6939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-ad08b2d18ef0",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-ad08b2d18ef0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TaHulVkK4cRtaZ5oQqzG0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_ead8b942-74ae-41da-a4ce-ddc55e54ee99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Deem Hills Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5050 W Andrea Ln, Phoenix, AZ 85083, USA",
      "poi_short_description": "Sprawling park featuring athletic areas, kids' play equipment & hiking trails with mountain views.",
      "poi_long_description": "Sprawling park featuring athletic areas, kids' play equipment & hiking trails with mountain views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e5dd-76f9-84a8-82105ed4e0d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e5dd-76f9-84a8-82105ed4e0d9",
        "storage_key": "property/6767906449167563/019f6c49-e5dd-76f9-84a8-82105ed4e0d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/deem-hills/trail-map",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609509298328657824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deem-hills-recreation-area",
      "poi_latitude": "33.7271778",
      "poi_longitude": "-112.1655547",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSA6wYdmK4cRoF_1jOHWNiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_49f7b4f0-c039-490d-83e7-676dbc0327aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Paseo Highlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3435 W Pinnacle Peak Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "Neighborhood park with a playground, a rock wall and a community center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-e903-752f-b149-18f209761d8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-e903-752f-b149-18f209761d8e",
        "storage_key": "property/6767906449167563/019f6c49-e903-752f-b149-18f209761d8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.phoenix.gov/parks/parks/alphabetical/p-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6208286377128891424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paseo-highlands-park",
      "poi_latitude": "33.696639",
      "poi_longitude": "-112.133937",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-262-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJubAk_fplK4cRIBSqLJFDKFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7104de9-3836-422a-98e9-e4f10cd480aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Cave Creek Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "37019 N Lava Ln, Cave Creek, AZ 85331, USA",
      "poi_short_description": "Scenic, 2,922-acre desert destination offering winding multi-use trails, campgrounds & picnic spots.",
      "poi_long_description": "Scenic, 2,922-acre desert destination offering winding multi-use trails, campgrounds & picnic spots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ec22-7129-bc49-a3e7efcd6301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ec22-7129-bc49-a3e7efcd6301",
        "storage_key": "property/6767906449167563/019f6c49-ec22-7129-bc49-a3e7efcd6301.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maricopacountyparks.net/park-locator/cave-creek-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14166983413417579357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cave-creek-regional-park",
      "poi_latitude": "33.8220131",
      "poi_longitude": "-112.0170964",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 602-506-2930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56ae-75ff-8bf3-5a5bde09dda9",
        "storage_key": "property/6767906449167563/019f6c46-56ae-75ff-8bf3-5a5bde09dda9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7EP81p8K4cRXRObx1o8m8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bc39d324-f70c-48ce-a49b-0c196588d7f1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "North Mountain Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "12950 N 7th St, Phoenix, AZ 85022, USA",
      "poi_short_description": "Visitor center with hiking trails, a gift shop, and book store, plus special events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ec1f-733b-8e4a-43d49951dcae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ec1f-733b-8e4a-43d49951dcae",
        "storage_key": "property/6767906449167563/019f6c49-ec1f-733b-8e4a-43d49951dcae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.northmountainvisitorcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7976611403225456103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-mountain-visitor-center",
      "poi_latitude": "33.5985498",
      "poi_longitude": "-112.0668249",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-343-5125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3zP6-ttK4cR512VMM-dsm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_7e61600f-ae47-4f5f-b12e-1cb55b8cfc01",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Honeywell Aerospace Technologies - Deer Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21111 N 19th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-4eb4-745d-a048-c57964c121e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c46-4eb4-745d-a048-c57964c121e4",
        "storage_key": "property/6767906449167563/019f6c46-4eb4-745d-a048-c57964c121e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=404546493164785334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell-aerospace-technologies---deer-valley",
      "poi_latitude": "33.6795907",
      "poi_longitude": "-112.09847",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2rtYXZvK4cRto43ZOQ8nQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_88963330-9f7c-4c21-a6ad-4ccb47fed119",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Luke Air Force Base",
      "poi_type": "Transportation & Transit",
      "poi_address": "14185 Falcon St, Luke AFB, AZ 85309, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ec80-75af-a4f4-b6c3973d1b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ec80-75af-a4f4-b6c3973d1b55",
        "storage_key": "property/6767906449167563/019f6c49-ec80-75af-a4f4-b6c3973d1b55.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.luke.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12441830729041852975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luke-air-force-base",
      "poi_latitude": "33.5414884",
      "poi_longitude": "-112.3755018",
      "poi_miles_from_property": "28.2",
      "poi_walking_minutes": "10 hours 8 mins",
      "poi_biking_minutes": "2 hours 28 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 623-856-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-094d-7664-b747-10f44c832e95",
        "storage_key": "property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6yVdGBGK4cRLzoU4CBDqqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_6d9ea1f0-ab6a-449a-be58-1af60c25a67e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Arizona State University West Valley Campus",
      "poi_type": "Education",
      "poi_address": "4701 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ee7b-7106-8587-6ec2d9b1e68f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ee7b-7106-8587-6ec2d9b1e68f",
        "storage_key": "property/6767906449167563/019f6c49-ee7b-7106-8587-6ec2d9b1e68f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857680985714674109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-west-valley-campus",
      "poi_latitude": "33.6079039",
      "poi_longitude": "-112.1609696",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-543-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56a0-76fa-9f48-7a14edf33b5e",
        "storage_key": "property/6767906449167563/019f6c46-56a0-76fa-9f48-7a14edf33b5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi7CNmFxpK4cRvUmZGyMWMc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_160fbc82-0633-4a6c-a8f7-55dc2062de93",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Banner - University Medical Center Phoenix",
      "poi_type": "Health and Wellness",
      "poi_address": "1111 E McDowell Rd, Phoenix, AZ 85006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ec37-71dc-aafc-c2394ab60f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ec37-71dc-aafc-c2394ab60f37",
        "storage_key": "property/6767906449167563/019f6c49-ec37-71dc-aafc-c2394ab60f37.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-university-medical-center-phoenix?y_source=1_MTE5MDczNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=5784332207521473033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner---university-medical-center-phoenix",
      "poi_latitude": "33.4645644",
      "poi_longitude": "-112.0573664",
      "poi_miles_from_property": "21.9",
      "poi_walking_minutes": "7 hours 59 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 602-839-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-5694-7114-a2d6-1151d888dae6",
        "storage_key": "property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoV6LoQ0SK4cRCSIr_H4TRlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_b36c260f-221b-4196-aa34-84787a1b4652",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Freeport-McMoRan Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 N Central Ave Ste 500a, Phoenix, AZ 85004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-ef39-7131-b2b2-3b52ac086e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-ef39-7131-b2b2-3b52ac086e71",
        "storage_key": "property/6767906449167563/019f6c49-ef39-7131-b2b2-3b52ac086e71.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "http://www.fcx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6543649427783782269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freeport-mcmoran-inc",
      "poi_latitude": "33.451859",
      "poi_longitude": "-112.0726869",
      "poi_miles_from_property": "22",
      "poi_walking_minutes": "8 hours 1 min",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 602-366-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-kxXyISK4cRfY-9HXy2z1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff413979-512c-4c08-9d96-d6afdd241158",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Carl T. Hayden Veterans' Administration Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "650 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-04f3-73f8-95f3-64d982c3b55a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c4a-04f3-73f8-95f3-64d982c3b55a",
        "storage_key": "property/6767906449167563/019f6c4a-04f3-73f8-95f3-64d982c3b55a.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "https://www.va.gov/phoenix-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001601183389442107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-t-hayden-veterans-administration-medical-center",
      "poi_latitude": "33.49731",
      "poi_longitude": "-112.0668282",
      "poi_miles_from_property": "19.3",
      "poi_walking_minutes": "7 hours 1 min",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 602-277-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-5694-7114-a2d6-1151d888dae6",
        "storage_key": "property/6767906449167563/019f6c46-5694-7114-a2d6-1151d888dae6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxLklI0SK4cRO-AtVOaI0vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_cd736f24-0375-46aa-bc18-1d0457710c83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Dignity Health St. Joseph's Hospital and Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "350 W Thomas Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-effd-7589-b67a-ca9fb21aa553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-effd-7589-b67a-ca9fb21aa553",
        "storage_key": "property/6767906449167563/019f6c49-effd-7589-b67a-ca9fb21aa553.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.commonspirit.org/find-a-location/dignity-health-st-josephs-hospital-and-medical-center-1344",
      "poi_directions_map_url": "https://maps.google.com/?cid=16691754161655818328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dignity-health-st-josephs-hospital-and-medical-center",
      "poi_latitude": "33.4820196",
      "poi_longitude": "-112.0790595",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 13 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 602-406-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c46-56af-755e-a621-a8f595347e86",
        "storage_key": "property/6767906449167563/019f6c46-56af-755e-a621-a8f595347e86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfUmGFkSK4cRWKikK_kFpec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_68265313-103b-41a7-8b1d-e4f307e75ecc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Maricopa County Treasurer",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 W Jefferson St #100, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-f0f9-75aa-83bd-79b23b17460c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-f0f9-75aa-83bd-79b23b17460c",
        "storage_key": "property/6767906449167563/019f6c49-f0f9-75aa-83bd-79b23b17460c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://treasurer.maricopa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=598395021876965531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maricopa-county-treasurer",
      "poi_latitude": "33.446491",
      "poi_longitude": "-112.0783779",
      "poi_miles_from_property": "21.8",
      "poi_walking_minutes": "8 hours 1 min",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 602-506-8511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-094d-7664-b747-10f44c832e95",
        "storage_key": "property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqa-4xSYSK4cRm7BWGhrtTQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_c537ae3f-40aa-482d-aba5-fcf0cce16ec1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "custom",
      "poi_name": "Phoenix City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Washington St, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c49-f236-745c-8c54-9c5fb663db6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f6c49-f236-745c-8c54-9c5fb663db6a",
        "storage_key": "property/6767906449167563/019f6c49-f236-745c-8c54-9c5fb663db6a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenix.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171114499780558672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-city-hall",
      "poi_latitude": "33.4487244",
      "poi_longitude": "-112.0773405",
      "poi_miles_from_property": "21.8",
      "poi_walking_minutes": "7 hours 59 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 602-262-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f6c4a-094d-7664-b747-10f44c832e95",
        "storage_key": "property/6767906449167563/019f6c4a-094d-7664-b747-10f44c832e95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTOCVyESK4cRUL-uC_EzpFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ad0775a610d7bdb6287adb6d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_101db4018294cb940b95f3bc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cf0698fe54745f9bcb35a29d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5df51935975071648215585b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_38b83a34fdfbc921912973a7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fbba1ca2258816764cef2933",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fd31af23dd754d2ce40f80d4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "I’m absolutely loving it here!  Anytime I ask one of the managers or agent a question, I’m always treated like I count!  Being part of this Ascend community can only get better!  I’m looking forward to having a “Get to know” your neighbor party at the clubhouse and pool area!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cd657baa333f5d451cbc7ef7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Love the community. Everyone is extremely nice and welcoming. The place is kept very clean and never have had any problems with bugs or neighbors",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_93c1d78d5b71b0da2f94c934",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Wonderful establishment. Clean pool, clean clubhouse, and then best part friendly staff. Clubhouse is available to play 8 ball pool anytime which I enjoy a lot.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3da9617474d3e3ebedfad7a4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Very nice location , the people are amazing.  Really enjoy the staff. If any concerns or questions arrive they are more than willing to help.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_64dac7c202952b7eba277da4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Aubrey was so helpful during the selection process and very patient with all of the questions and emails I had for her. I hope I continue to enjoy moving over the next year",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cb0551ee4ce5d0f8b27587a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Amazing place! Great environment and we love the quiet space. And the pool is amazing lol. Can’t wait for the winter to use the fire pit. One of our favorite things for the winter !",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0eec7f479b380374451bde15",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Really enjoying living in this community, I moved in to my apartment early August from Germany and have felt right at home. The area is very well kept and the staff is 10/10.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5919d12a0a3af550d10f27fb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "The place is beautiful, but parking is hard, especially if ypu want to invite people over. Overall, it's been a really nice expirence!!! Great staff!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4ad94b5167a935e47c995048",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Amazing front office staff and the apartment complex is nice & clean. The Move in process was fairly easy, and Julia was a great help, she walked us through everything!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_afd39958f6f6c2d42cd4d99b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "The apartment's been great—quiet, spacious, and the 24/7 gym is a nice addition. Love the layout of the apartment. I just wish people picked up after their pets more.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b13ffb736510edf2c0d5fc90",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Community is quiet, staff is friendly and helpful, and neighbors are nice. The facilities are really fantastic as well. I'm very happy to be a resident.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_078bbea4d4ca243d45f21127",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "The amenities are well maintained and though we are quite close to the highway you can almost never hear anything once you’re inside your unit.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e336f0a489e97e211847a5f3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Love the community & location of this place. The staff and residents are very welcoming and nice. There are tons of things to do around the community that I love; like the gym, swimming, fireplace outside, and games",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4bd381578cf7958957831060",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Everything around the apartment complex is wonderful, however I have been noticing residence not being responsible and cleaning up after there pets! Especially the dog parks!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_382b531196e2ffc7554ead2c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "It’s a really clean environment, love all the amenities! would definitely reccomend !! All neighbors are friendly and follow all apartments guidelines. love the two car garage it really comes in handy !",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_94c9e90eef257c629faa5e12",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Great place to rent so far. Love the security and community. Very quiet. Nice gym. Has dog wash! Always wanted to live in apartments with a dog wash",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_046743c46c9553b9d7777743",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "This apartment has a peaceful environment, and the gym is clean and well-equipped.\nThe staff and management are very dedicated and promptly address any issues we encounter.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7ebddbf59ebae86e088c2131",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "We love it here! The community is well kept and the maintenance staff is excellent with addressing any issues that may arise. We have been very happy with our choice of residence!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ee110df9200d422df75b354d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Gorgeous apartment, beautiful grounds, ultra friendly office staff, quick work order response and resolution, 10/10 would (and have) recommend.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_25f45cfe9e2ee174dc48a067",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Nice place. Resort style.  well built! Quiet any maintenance issues are resolved quickly. Staff friendly little noise from highway hasn't been a problem.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a85a06547df2fee4a6561a75",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Great experience living here so far! I love living in new apartments. Super big living room and kitchen! It is a pretty quiet community as well.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_98d2937885bccce684b0fe02",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "So far it's been pretty simple to move in and get started. I haven't really made up my mind on what to say or think as it's still too new to determine.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7cd248214cc337b799e7a928",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "We love living here, the community is quite and everyone is friendly. The amenities are well kept and are beautiful.  Staff in the office are awesome",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_897da681d33dd0b64d41b2a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "We have loved living here! The management has been so nice and friendly and the community is well kept and quiet! There are many amazing and well kept amenities too!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0d040c4d8169ca98084f73d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "This is best community I have lived in!!!! Everyone is so friendly and the community is kept cleaned. Aubrey and Olivia are the absolute best. 10/10 recommend!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_153c7584908d6ac683cc097c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "good apartment enjoy it so far, it has a lot of different events and great pool as well as great amentaties. Overall a great experience living in Ascend",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b661e3ba0f9e42a8736b1e45",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Love the proximity to my job and the amenities, small issues here and there but most of it is fixable. Peaceful neighbors and spacious floor plans. But it would be better if there was a back road out of the complex so you didn’t have to make an entire loop around the I17 to get anywhere",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4f35011d7ff95ecb18d35f53",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Management is really responsible in keeping areas clean and friendly for all people. I really enjoy this apartment complex. The events they hold to bring everyone together is kind and very generous.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fdc841d05d883e4d0a6e82ad",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Office staff are all friendly, patient and willing to answer any questions, even they are not the DRI but are generously direct me to the right contact",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e338a37978a3dd89b2aca78a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "This is a beautiful community and in a great location! Staff is very welcoming. The community is very clean and safe. I wood recommend this apartment to anyone and everyone of all ages!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4ccfe50bda824ec0b479e3a9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "This is a beautiful complex with families and couples of all ages! Everyone is very welcoming. The pool area is one of my favorite areas! It feels like a resort! Our neighbors and their pets have been extremely nice! Highly recommend!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9b32db464a89b793777fe07b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Mo/Kat are awesome. Super patient and helpful. They helped us with a list of questions we had and helped us understand our contract. So far the apartment is great, but Mo/Kat(?) are the best.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ef516250684e4054ab3d2e2b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Great community, but noisy due to the proximity to I17 and no sound wall along this portion of the highway. The maintenance crew is always very responsive and is great at ensuring issues are addressed.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_973f640e4b9976b51a3553d5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "So far, moving into the Ascend at Black Canyon has been a great experience. All of the apartment homes are brand new with beautiful wood flooring and carpet throughout.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_17c1d3666fcdfa641118ae93",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "This is a great community.\nI’ve been using the gym recently, and the equipment is very well-equipped.\nThe swimming pool is also maintained very clean and nice.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5d25b4ee6487a1ea7a397a82",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Nices places. Great unit. Love the style apartment. Like the gym. Like that it's quite but don't like that people smoke weed or pick up after there dog",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0752da9a1509e1b6c2316fa4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Place is fantastic! too bad some people are ungrateful and are not considerate and trash area where ever they go . i still give 5 stars for the place",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fbaf5913dc5940f0c8f39575",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Wonderful apartment complex! Maintenance solves issues immediately! Clean complex and neighbors are nice! Highly recommend! Perfect complex for young people or families!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5fa295d2e9e9707c855eb3a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Been here for almost 6 months soon, and it's great I work from home and am able to enjoy a quiet environment with wonderful amenities at my disposal.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a02678d61ee3550481f9d5e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "I love how open and spacious it is here :) I just wished I had a private back yard for my pup, but outside of that everything is wonderful :)",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_84ce0474e60fa758c218c221",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Moving can be a stressful experience in general, but I will say finding Ascend Black Canyon and working with Sophia made it as stress-free as it possibly could have been. The process was seamless from start to finish and Sophia was there to answer any of the questions that I had during the process. The entire staff was very accommodating if I had additional questions.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_be7a4aef454bb11ac0925967",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Ascend at Black Canyon made it easy to apply and begin a lease! Everyone was very helpful in the process.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a515525c601f2aeef849f57d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Beautiful property, I get nothing but compliments from my friends and family on how nice my apartment is! Staff is super friendly and responsive, I’ve been here for over a year and plan to stay for many more!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_75b394f887903fc869dfd5d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Office staff is very approachable, friendly, and knowledgeable.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_e39e06107c0e3f887981fd82",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "Peaceful community. Beautiful living spaces",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_81b43f56fee7aaa4e607b99a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "5",
      "name": "false",
      "text": "Ascend at Black Canyon is an amazing apartment complex with well trained professional staff who are always there for you with any questions, concerns or help you may need in ur process. As for the apartments themselves we walked into a freshly cleaned apartment ready to move everything in, no need to clean before you move your stuff in! Overall this complex is amazing and I would recommend to everyone!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_df4f9d359ac5f4e3ce0ec2a8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "rating": "4",
      "name": "false",
      "text": "While there were some small things missed in our apartment, overall it is a great place to live. The apartment is very nice, the space and storage are the best we’ve had in an apartment. The community is very calm and the amenities are great to use.",
      "date": "false",
      "title": "Verified Renter"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a062d8-ff40-75e0-85aa-e377aa27cba3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Black Canyon Luxury Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "luxury-apartments-resort-style-pool-phoenix",
      "search_query": "luxury apartments with resort-style pool in Phoenix",
      "category": "Amenity",
      "h1_title": "Luxury Apts with Resort-Style Pool in Phoenix",
      "h2_subtitle": "Experience the best of luxury living in Phoenix. Our unique resort-style pool makes every day feel like a vacation.",
      "page_copy": "Welcome to Black Canyon Luxury Apartments, where sophistication meets comfort in the heart of Phoenix. Dive into the ultimate lifestyle experience with our luxurious resort-style pool, perfect for unwinding and savoring Arizona's sunny days. Nestled in the vibrant Deer Valley neighborhood, this exquisite community offers more than just a remarkable pool. Enjoy smoke-free living in finely crafted spaces featuring fully equipped gourmet kitchens with granite counters and energy-efficient stainless steel appliances.\n\nAs a resident, you are invited to indulge in an array of amenities tailored to enhance convenience and leisure. The community clubhouse stands ready for gatherings and events, while our dedicated pet washing station ensures even your furry friends enjoy the upscale lifestyle. At Black Canyon Luxury Apartments, discover the perfect balance of elegance and relaxation in Phoenix's most desirable location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with Resort-Style Pool in Phoenix",
      "seo_description": "Discover luxury living in Phoenix with resort-style pool. Experience Black Canyon's premium amenities and vibrant Deer Valley location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-deer-valley",
      "search_query": "in-unit laundry apartments near Deer Valley",
      "category": "Amenity",
      "h1_title": "Apts with In-Unit Laundry Near Deer Valley",
      "h2_subtitle": "Convenience meets luxury with in-unit laundry facilities. Discover premium living close to Deer Valley today.",
      "page_copy": "Discover unparalleled convenience at Black Canyon Luxury Apartments, offering in-unit laundry options near the vibrant Deer Valley region. Say goodbye to shared laundry spaces and embrace the ease of doing laundry in the privacy of your own apartment. This modern convenience complements a lifestyle of comfort and relaxation in the heart of Phoenix.\n\nOur smoke-free community pairs these in-unit amenities with exceptional features like fully equipped gourmet kitchens and energy-efficient stainless steel appliances. Residents enjoy an impressive selection of community amenities, including a pet washing station for furry friends and a welcoming clubhouse, perfect for social gatherings. At Black Canyon, comfort is at your fingertips, making it the ideal choice for discerning renters in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with In-Unit Laundry Near Deer Valley",
      "seo_description": "Explore in-unit laundry apartments close to Deer Valley. Enjoy convenience and luxury at Black Canyon, Phoenix's premier living destination.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-maricopa-county",
      "search_query": "energy efficient apartments in Maricopa County",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apts in Maricopa County",
      "h2_subtitle": "Embrace eco-friendly living in Maricopa County. Experience the benefits of energy efficient apartments today.",
      "page_copy": "Welcome to Black Canyon Luxury Apartments, where energy efficiency and modern convenience blend seamlessly in the sought-after Maricopa County. Our apartments come equipped with state-of-the-art, energy-efficient stainless steel appliances, designed to reduce your environmental footprint while enhancing everyday comfort. Nestled in Phoenix's Deer Valley neighborhood, our community represents the ideal choice for those prioritizing sustainability.\n\nBeyond energy efficiency, Black Canyon offers an array of top-notch amenities, including smoke-free living spaces and gourmet kitchens with granite counters. Our amenities ensure a premium lifestyle, with highlights such as a resort-style pool, community clubhouse, and a dedicated pet washing station. Experience sustainable luxury at its finest in one of Phoenix's most vibrant areas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apts in Maricopa County",
      "seo_description": "Discover energy efficient living in Maricopa County. Black Canyon offers premium apartments equipped with eco-friendly features in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pet-wash-station-phoenix",
      "search_query": "dog-friendly apartments with pet wash station in Phoenix",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apts with Pet Wash Station",
      "h2_subtitle": "Enjoy dog-friendly living with top amenities in Phoenix. Our pet wash station ensures convenience for you and your furry friend.",
      "page_copy": "Welcome to Black Canyon Luxury Apartments, expertly designed to provide a welcoming environment for both you and your four-legged companions. Located in Phoenix, our pet-friendly community is a haven for pet owners, offering a convenient pet wash station that makes grooming and caring for your furry friends easier than ever.\n\nOur apartments don’t just cater to pets; they provide an elevated living experience with a range of upscale amenities. Residents enjoy fully equipped gourmet kitchens featuring granite countertops and energy-efficient, stainless steel appliances. Nestled in the desirable Deer Valley neighborhood, this smoke-free community promises both comfort and convenience, with features like a resort-style pool and a vibrant community clubhouse. Discover what makes Black Canyon the ideal place for you and your pet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apts with Pet Wash Station",
      "seo_description": "Explore pet-friendly living in Phoenix. Black Canyon offers dog-friendly apartments with a convenient pet wash station, perfect for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "apartments-gourmet-kitchens-phoenix",
      "search_query": "apartments with fully equipped gourmet kitchens in Phoenix",
      "category": "Amenity",
      "h1_title": "Apts with Gourmet Kitchens in Phoenix",
      "h2_subtitle": "Experience culinary excellence in Phoenix. Our apartments feature fully equipped gourmet kitchens, enhancing your cooking experience.",
      "page_copy": "Discover the perfect blend of luxury and functionality at Black Canyon Luxury Apartments in Phoenix, where each unit boasts a fully equipped gourmet kitchen. Our kitchens are designed to fit the needs of cooking enthusiasts and novices alike, featuring exquisite granite countertops and top-of-the-line, stainless steel energy-efficient appliances. Located in the vibrant Deer Valley neighborhood, Black Canyon offers a premier living experience that prioritizes both comfort and style.\n\nIn addition to our exceptional kitchen amenities, our community provides a plethora of upscale features that enhance the living experience. Enjoy the smokeless atmosphere while indulging in our resort-like pool or socialize in the resident-friendly clubhouse. Pet owners will appreciate the dedicated pet washing station, ensuring every resident's needs are met. With these amenities, Black Canyon Luxury Apartments stands out as the finest choice for those seeking gourmet living in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Gourmet Kitchens in Phoenix",
      "seo_description": "Discover apartments with fully equipped gourmet kitchens in Phoenix. Enjoy luxurious living at Black Canyon with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-phoenix-az",
      "search_query": "1 bedroom apartment phoenix az",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in Phoenix, AZ",
      "h2_subtitle": "Find your perfect 1 bedroom apartment in Phoenix, AZ. Stylish, comfortable, and situated in the vibrant Deer Valley neighborhood.",
      "page_copy": "Welcome to Black Canyon Luxury Apartments, where comfort meets convenience in the heart of Phoenix, AZ. Our stylish 1 bedroom apartments are designed with modern living in mind, offering spacious layouts that include fully equipped gourmet kitchens with granite countertops and energy-efficient stainless steel appliances. Experience a lifestyle of elegance and efficiency in vibrant Deer Valley.\n\nBeyond the chic interiors, our community offers exceptional amenities such as a smoke-free environment, a resort-style pool, and a welcoming clubhouse perfect for social gatherings. We also cater to pet owners with our on-site pet washing station. Located in Maricopa County, Black Canyon provides the perfect balance of tranquility and accessibility, making it the ideal choice for anyone looking for a 1 bedroom apartment in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Phoenix, AZ",
      "seo_description": "Explore 1 bedroom apartments in Phoenix, AZ. Black Canyon offers luxury living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "two-bedroom-luxury-apartments-deer-valley",
      "search_query": "2 bedroom luxury apartments deer valley",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Luxury Apartments in Deer Valley",
      "h2_subtitle": "Discover the allure of 2 bedroom luxury apartments in Deer Valley. Experience high-end living with unrivaled amenities.",
      "page_copy": "At Black Canyon Luxury Apartments, we offer exquisite 2 bedroom luxury apartments nestled in the serene Deer Valley neighborhood. Each apartment is meticulously designed to deliver both comfort and elegance, featuring gourmet kitchens equipped with granite countertops and stainless steel energy-efficient appliances. These spacious layouts are ideal for families or roommates seeking a high-quality living experience in a prime Phoenix location.\n\nOur community is rich with amenities, making it a perfect fit for those who value luxury. Residents can enjoy the smoke-free environment, relax in the community clubhouse, or make use of the convenient pet washing station for furry friends. The combination of high-end apartment features and outstanding community amenities makes Black Canyon the premier choice for luxury living in Deer Valley, Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Luxury Apartments in Deer Valley",
      "seo_description": "Explore 2 bedroom luxury apartments in Deer Valley. Black Canyon offers upscale living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "three-bedroom-affordable-apartments-maricopa",
      "search_query": "3 bedroom affordable apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Affordable Apts in Maricopa County",
      "h2_subtitle": "Discover affordable 3 bedroom apartments in Maricopa County. Enjoy comfortable living with premium amenities at Black Canyon Luxury Apartments.",
      "page_copy": "Find the perfect home for your family at Black Canyon Luxury Apartments, offering spacious and affordable 3 bedroom apartments in Maricopa County. Each apartment is thoughtfully designed with fully equipped gourmet kitchens featuring granite countertops and energy-efficient stainless steel appliances, ensuring a quality living experience without compromising on elegance or affordability.\n\nLocated in the vibrant Deer Valley area of Phoenix, our community provides an array of amenities perfect for all lifestyles. Relish in the smoke-free atmosphere, unwind at the community clubhouse, or take advantage of the convenient pet washing station. Black Canyon stands out as the ideal choice for those seeking affordable luxury in a prime location, combining affordability with top-tier amenities for a well-rounded living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Affordable Apts in Maricopa County",
      "seo_description": "Affordable 3 bedroom apartments in Maricopa County at Black Canyon. Enjoy modern living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-chamberlain-university-phx",
      "search_query": "luxury apartments near Chamberlain University Phoenix",
      "category": "School",
      "h1_title": "Luxury Apartments Near Chamberlain University",
      "h2_subtitle": "Explore luxury living near Chamberlain University, Phoenix. Black Canyon offers premium amenities and a convenient location in Deer Valley.",
      "page_copy": "Discover unmatched comfort at Black Canyon Luxury Apartments, ideally located near Chamberlain University in Phoenix, AZ. Perfect for students or professionals seeking proximity to campus, our luxury apartments offer spacious living areas with state-of-the-art amenities, including gourmet kitchens equipped with granite countertops and stainless steel energy-efficient appliances.\n\nOur community is designed with well-being and entertainment in mind, featuring a smoke-free environment, an inviting community clubhouse, and a handy pet washing station. Situated in the Deer Valley neighborhood, residents enjoy easy access to educational and professional opportunities while relishing in the tranquility and convenience Black Canyon provides. Choose us for a sophisticated lifestyle and effortless access to Chamberlain University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Chamberlain University",
      "seo_description": "Luxury living near Chamberlain University. Black Canyon offers top amenities and a prime location in Phoenix. Perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "apartments-near-honorhealth-deer-valley-medical-center",
      "search_query": "apartments near HonorHealth Deer Valley Medical Center Phoenix",
      "category": "Hospital",
      "h1_title": "Apartments Near HonorHealth Deer Valley",
      "h2_subtitle": "Find the perfect apartment near HonorHealth Deer Valley Medical Center. Enjoy upscale amenities and a convenient location at Black Canyon.",
      "page_copy": "Black Canyon Luxury Apartments offers an ideal location for those seeking apartments close to HonorHealth Deer Valley Medical Center in Phoenix. Our community provides easy access for healthcare professionals and patients alike, with an array of luxurious features that enhance comfort and convenience. Each apartment boasts a gourmet kitchen with granite countertops and energy-efficient stainless steel appliances, ensuring a modern and efficient living experience.\n\nNestled in the vibrant Deer Valley area, our smoke-free community is perfect for individuals and families looking to balance work with leisure. The community clubhouse is great for unwinding, while the pet washing station makes it easy to care for furry companions. Embrace the best of both worlds with serene, high-end living at Black Canyon, right near HonorHealth Deer Valley Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HonorHealth Deer Valley",
      "seo_description": "Discover apartments near HonorHealth Deer Valley Medical Center. Enjoy luxury living at Black Canyon with prime amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "apartments-near-thunderbird-conservation-park-phoenix",
      "search_query": "apartments near thunderbird conservation park phoenix",
      "category": "Park",
      "h1_title": "Apartments Near Thunderbird Conservation Park",
      "h2_subtitle": "Discover beautiful apartments near Thunderbird Conservation Park in Phoenix. Enjoy convenient access to nature and luxurious living at Black Canyon.",
      "page_copy": "Experience the perfect blend of nature and luxury at Black Canyon Luxury Apartments, located near the serene Thunderbird Conservation Park in Phoenix. Our community offers effortless access to outdoor recreation, making it a haven for nature enthusiasts who wish to enjoy hiking, biking, and scenic views right at their doorstep. Nestled in the vibrant Deer Valley neighborhood, our apartments offer a peaceful retreat while maintaining proximity to all that Phoenix has to offer.\n\nEach residence features a fully equipped gourmet kitchen with granite countertops and energy-efficient stainless steel appliances. Enjoy a smoke-free environment and take advantage of our community amenities, including a clubhouse for social gatherings and a pet washing station, ensuring all your needs are met. Choose Black Canyon for upscale living mere moments from the natural beauty of Thunderbird Conservation Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thunderbird Conservation Park",
      "seo_description": "Find apartments near Thunderbird Conservation Park in Phoenix. Black Canyon offers luxury living with easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167563",
      "source": "generator",
      "page_item_url": "black-canyon-apartments-near-deer-valley-park-maricopa",
      "search_query": "black canyon apartments near deer valley park maricopa county",
      "category": "Park",
      "h1_title": "Black Canyon Apartments Near Deer Valley Park",
      "h2_subtitle": "Live near Deer Valley Park at Black Canyon Apartments in Maricopa County. Enjoy luxury amenities and a prime location for all lifestyles.",
      "page_copy": "Welcome to Black Canyon Luxury Apartments, perfectly situated near Deer Valley Park in Maricopa County. Our community offers the perfect blend of urban convenience and leisure with access to one of Phoenix's most cherished green spaces. Enjoy strolls or recreational activities at Deer Valley Park, while residing in a community that prioritizes luxury and comfort.\n\nBlack Canyon's apartments are designed with premium amenities, including fully-equipped gourmet kitchens featuring granite countertops and stainless steel energy-efficient appliances. Residents benefit from a smoke-free environment, a welcoming community clubhouse, and a convenient pet washing station. Located in the heart of Deer Valley, our apartments provide a serene and complete living experience, ideal for families, professionals, and anyone seeking a dynamic lifestyle near Deer Valley Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Black Canyon Apts Near Deer Valley Park",
      "seo_description": "Live at Black Canyon near Deer Valley Park in Maricopa County. Enjoy luxury amenities and a perfect location for recreation and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12531712096"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=4d8f67cd19a1ae28f0071edb5573c1313415dbf4f9ae5870ceec3618c100ecb960275f0d10efc7c40ad9b27ecda149d8\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N62RNS5M"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1205BLCN"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "56463520032"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1xrlxvkx"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Black_Canyon_Luxury/scheduletourwidget/9yzx1hEvrFwp7rtsGf/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVVd1VrbE0rVFdXeU9USjdNZ2lYZ3c9PSIsInZhbHVlIjoiVVRzMzhSUGEzckQ2dVNxS2x2czAxQT09IiwibWFjIjoiZTAwZjQ0NDcxMTE5YjcwNDI0OTBiNGU3ZDA3NjFiNTJmNjQ1OWFhNDE2ZjMyNjI2NTA3MGYwMGE0NTFmYzJiYSJ9"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12531712096",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=4d8f67cd19a1ae28f0071edb5573c1313415dbf4f9ae5870ceec3618c100ecb960275f0d10efc7c40ad9b27ecda149d8\"></script>",
  "custom_google_gtm_id": "GTM-N62RNS5M",
  "custom_rollout_phase": "Milburn 2",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "1205BLCN",
  "custom_hubspot_company_id": "56463520032",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1xrlxvkx",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Black_Canyon_Luxury/scheduletourwidget/9yzx1hEvrFwp7rtsGf/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVVd1VrbE0rVFdXeU9USjdNZ2lYZ3c9PSIsInZhbHVlIjoiVVRzMzhSUGEzckQ2dVNxS2x2czAxQT09IiwibWFjIjoiZTAwZjQ0NDcxMTE5YjcwNDI0OTBiNGU3ZDA3NjFiNTJmNjQ1OWFhNDE2ZjMyNjI2NTA3MGYwMGE0NTFmYzJiYSJ9",
  "custom_audioeye_site_id": "40c93cab-2160-4330-94c5-fdf821b3c596",
  "custom_audioeye_site_hash": "1d3e375f4d2959de33d395a551771d06"
};

export const generatedAt = '2026-11-03T16:24:21.474Z';
